/*******************************************************************************
 * This file was automatically generated. DO NOT MODIFY IT BY HAND.
 * Instead, modify the xinglet routes and run `bun run monorepo code-generator` to regenerate this file.
 *******************************************************************************/

/**
 * - Xinglet: `@xing-com/crate-demo-commands`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_COMMANDS_PATH = '/commands';

/**
 * - Xinglet: `@xing-com/crate-demo-i18n`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_I18N_PATH = '/i18n';

/**
 * - Xinglet: `@xing-com/crate-demo-global-bundled-packages`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_PACKAGES_PATH = '/packages';

/**
 * - Xinglet: `@xing-com/crate-demo-react-state`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_REACT_STATE_PATH = '/react-state';

/**
 * - Xinglet: `@xing-com/crate-demo-server-data`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_SERVER_DATA_PATH = '/server-data';

/**
 * - Xinglet: `@xing-com/crate-demo-service-worker`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_SERVICE_WORKER_PATH = '/service-worker';

/**
 * - Xinglet: `@xing-com/crate-demo-shared-context`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_SHARED_CONTEXT_PATH = '/shared-context';

/**
 * - Xinglet: `@xing-com/crate-demo-suspense`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_SUSPENSE_PATH = '/suspense';

/**
 * - Xinglet: `@xing-com/crate-demo-tests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_TESTS_DATA_FETCHING_PATH = '/tests/data-fetching';

/**
 * - Xinglet: `@xing-com/crate-demo-tests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_TESTS_HIDDEN_PAGE_PATH = '/tests/hidden-page';

/**
 * - Xinglet: `@xing-com/crate-demo-tests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_TESTS_REDIRECT_TO_HIDDEN_PAGE_PATH =
  '/tests/redirect-to-hidden-page';

/**
 * - Xinglet: `@xing-com/crate-demo-tests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_TESTS_SSR_PATH = '/tests/ssr';

/**
 * - Xinglet: `@xing-com/crate-demo-tests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_TESTS_PATH = '/tests';

/**
 * - Xinglet: `@xing-com/crate-demo-upload`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_UPLOAD_PATH = '/upload';

/**
 * - Xinglet: `@xing-com/crate-demo-websocket`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_WEBSOCKET_PATH = '/websocket';

/**
 * - Xinglet: `@xing-com/crate-demo-x1`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_XING_ONE_PATH = '/xing-one';

/**
 * - Xinglet: `@xing-com/crate-demo-welcome`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const DEMO_PATH = '/';

/**
 * - Xinglet: `@xing-com/crate-activity-center-checkout-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_ACTIVITY_PATH = '/activity';

export type XingBrandmanagerIdAdminNewsSettingsPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/admin/news-settings`
 */
export const getXingBrandmanagerIdAdminNewsSettingsPath = ({
  id,
}: XingBrandmanagerIdAdminNewsSettingsPathParams): `/brandmanager/${string}/admin/news-settings` =>
  `/brandmanager/${encodeURIComponent(id)}/admin/news-settings`;

export type XingBrandmanagerIdAdminPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/admin`
 */
export const getXingBrandmanagerIdAdminPath = ({
  id,
}: XingBrandmanagerIdAdminPathParams): `/brandmanager/${string}/admin` =>
  `/brandmanager/${encodeURIComponent(id)}/admin`;

export type XingBrandmanagerIdNewsReachPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/news-reach`
 */
export const getXingBrandmanagerIdNewsReachPath = ({
  id,
}: XingBrandmanagerIdNewsReachPathParams): `/brandmanager/${string}/news-reach` =>
  `/brandmanager/${encodeURIComponent(id)}/news-reach`;

export type XingBrandmanagerIdPageReachFollowersPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/page-reach/followers`
 */
export const getXingBrandmanagerIdPageReachFollowersPath = ({
  id,
}: XingBrandmanagerIdPageReachFollowersPathParams): `/brandmanager/${string}/page-reach/followers` =>
  `/brandmanager/${encodeURIComponent(id)}/page-reach/followers`;

export type XingBrandmanagerIdPageReachProfileAnalysisPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/page-reach/profile-analysis`
 */
export const getXingBrandmanagerIdPageReachProfileAnalysisPath = ({
  id,
}: XingBrandmanagerIdPageReachProfileAnalysisPathParams): `/brandmanager/${string}/page-reach/profile-analysis` =>
  `/brandmanager/${encodeURIComponent(id)}/page-reach/profile-analysis`;

export type XingBrandmanagerIdPageReachVisitorsPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/page-reach/visitors`
 */
export const getXingBrandmanagerIdPageReachVisitorsPath = ({
  id,
}: XingBrandmanagerIdPageReachVisitorsPathParams): `/brandmanager/${string}/page-reach/visitors` =>
  `/brandmanager/${encodeURIComponent(id)}/page-reach/visitors`;

export type XingBrandmanagerIdPageReachPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/brandmanager/:id/page-reach`
 */
export const getXingBrandmanagerIdPageReachPath = ({
  id,
}: XingBrandmanagerIdPageReachPathParams): `/brandmanager/${string}/page-reach` =>
  `/brandmanager/${encodeURIComponent(id)}/page-reach`;

/**
 * - Xinglet: `@xing-com/crate-companies-brandmanager`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_BRANDMANAGER_PATH = '/brandmanager';

/**
 * - Xinglet: `@xing-com/crate-business-solutions-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_BUSINESS_SOLUTIONS_PATH = '/business-solutions';

export type XingChatsEmailClickActionsTokenPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/email-click-actions/:token`
 */
export const getXingChatsEmailClickActionsTokenPath = ({
  token,
}: XingChatsEmailClickActionsTokenPathParams): `/chats/email-click-actions/${string}` =>
  `/chats/email-click-actions/${encodeURIComponent(token)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_NEW_GROUP_PATH = '/chats/new/group';

export type XingChatsNewIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/new/:id`
 */
export const getXingChatsNewIdPath = ({
  id,
}: XingChatsNewIdPathParams): `/chats/new/${string}` =>
  `/chats/new/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_NEW_PATH = '/chats/new';

export type XingChatsRecruiterChatIdPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/recruiter/:chatId`
 */
export const getXingChatsRecruiterChatIdPath = ({
  chatId,
}: XingChatsRecruiterChatIdPathParams): `/chats/recruiter/${string}` =>
  `/chats/recruiter/${encodeURIComponent(chatId)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_RECRUITER_PATH = '/chats/recruiter';

export type XingChatsSearchChatsChatIdPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/search/chats/:chatId`
 */
export const getXingChatsSearchChatsChatIdPath = ({
  chatId,
}: XingChatsSearchChatsChatIdPathParams): `/chats/search/chats/${string}` =>
  `/chats/search/chats/${encodeURIComponent(chatId)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_SEARCH_CHATS_PATH = '/chats/search/chats';

export type XingChatsSearchMessagesChatIdMessageIdPathParams = {
  chatId: string;
  messageId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/search/messages/:chatId/:messageId`
 */
export const getXingChatsSearchMessagesChatIdMessageIdPath = ({
  chatId,
  messageId,
}: XingChatsSearchMessagesChatIdMessageIdPathParams): `/chats/search/messages/${string}/${string}` =>
  `/chats/search/messages/${encodeURIComponent(chatId)}/${encodeURIComponent(messageId)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_SEARCH_MESSAGES_PATH = '/chats/search/messages';

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_SETTINGS_PATH = '/chats/settings';

export type XingChatsUnreadChatIdPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/unread/:chatId`
 */
export const getXingChatsUnreadChatIdPath = ({
  chatId,
}: XingChatsUnreadChatIdPathParams): `/chats/unread/${string}` =>
  `/chats/unread/${encodeURIComponent(chatId)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_UNREAD_PATH = '/chats/unread';

export type XingChatsChatIdDetailsAddPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/details/add`
 */
export const getXingChatsChatIdDetailsAddPath = ({
  chatId,
}: XingChatsChatIdDetailsAddPathParams): `/chats/${string}/details/add` =>
  `/chats/${encodeURIComponent(chatId)}/details/add`;

export type XingChatsChatIdDetailsPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/details`
 */
export const getXingChatsChatIdDetailsPath = ({
  chatId,
}: XingChatsChatIdDetailsPathParams): `/chats/${string}/details` =>
  `/chats/${encodeURIComponent(chatId)}/details`;

export type XingChatsChatIdMissingInformationPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/missingInformation`
 */
export const getXingChatsChatIdMissingInformationPath = ({
  chatId,
}: XingChatsChatIdMissingInformationPathParams): `/chats/${string}/missingInformation` =>
  `/chats/${encodeURIComponent(chatId)}/missingInformation`;

export type XingChatsChatIdTemplatesNewPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/templates/new`
 */
export const getXingChatsChatIdTemplatesNewPath = ({
  chatId,
}: XingChatsChatIdTemplatesNewPathParams): `/chats/${string}/templates/new` =>
  `/chats/${encodeURIComponent(chatId)}/templates/new`;

export type XingChatsChatIdTemplatesTemplateIdEditPathParams = {
  chatId: string;
  templateId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/templates/:templateId/edit`
 */
export const getXingChatsChatIdTemplatesTemplateIdEditPath = ({
  chatId,
  templateId,
}: XingChatsChatIdTemplatesTemplateIdEditPathParams): `/chats/${string}/templates/${string}/edit` =>
  `/chats/${encodeURIComponent(chatId)}/templates/${encodeURIComponent(templateId)}/edit`;

export type XingChatsChatIdTemplatesPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/templates`
 */
export const getXingChatsChatIdTemplatesPath = ({
  chatId,
}: XingChatsChatIdTemplatesPathParams): `/chats/${string}/templates` =>
  `/chats/${encodeURIComponent(chatId)}/templates`;

export type XingChatsChatIdMessageIdPathParams = {
  chatId: string;
  messageId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId/:messageId`
 */
export const getXingChatsChatIdMessageIdPath = ({
  chatId,
  messageId,
}: XingChatsChatIdMessageIdPathParams): `/chats/${string}/${string}` =>
  `/chats/${encodeURIComponent(chatId)}/${encodeURIComponent(messageId)}`;

export type XingChatsChatIdPathParams = {
  chatId: string;
};

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 * - Path: `/chats/:chatId`
 */
export const getXingChatsChatIdPath = ({
  chatId,
}: XingChatsChatIdPathParams): `/chats/${string}` =>
  `/chats/${encodeURIComponent(chatId)}`;

/**
 * - Xinglet: `@xing-com/crate-messenger-index`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_CHATS_PATH = '/chats';

/**
 * - Xinglet: `@xing-com/crate-coaches-sunset`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COACHES_PATH = '/coaches';

export type XingCompaniesIndustriesIndustrySegmentPathParams = {
  industry: string;
  segment: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/companies/industries/:industry/:segment`
 */
export const getXingCompaniesIndustriesIndustrySegmentPath = ({
  industry,
  segment,
}: XingCompaniesIndustriesIndustrySegmentPathParams): `/companies/industries/${string}/${string}` =>
  `/companies/industries/${encodeURIComponent(industry)}/${encodeURIComponent(segment)}`;

export type XingCompaniesIndustriesIndustryPathParams = {
  industry: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/companies/industries/:industry`
 */
export const getXingCompaniesIndustriesIndustryPath = ({
  industry,
}: XingCompaniesIndustriesIndustryPathParams): `/companies/industries/${string}` =>
  `/companies/industries/${encodeURIComponent(industry)}`;

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_INDUSTRIES_PATH = '/companies/industries';

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_MOST_VISITED_PATH = '/companies/most_visited';

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_MY_COMPANIES_EDIT_PATH =
  '/companies/my_companies_edit';

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_MY_COMPANIES_FOLLOW_PATH =
  '/companies/my_companies_follow';

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_SUBSCRIPTIONS_PATH = '/companies/subscriptions';

/**
 * - Xinglet: `@xing-com/crate-companies-companies-frontend`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_COMPANIES_PATH = '/companies';

export type XingComplaintsReportIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-complaints-wizard`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/complaints/report/:id`
 */
export const getXingComplaintsReportIdPath = ({
  id,
}: XingComplaintsReportIdPathParams): `/complaints/report/${string}` =>
  `/complaints/report/${encodeURIComponent(id)}`;

export type XingComplaintsReviewIdTokenPathParams = {
  id: string;
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-complaints-review`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/complaints/review/:id/:token`
 */
export const getXingComplaintsReviewIdTokenPath = ({
  id,
  token,
}: XingComplaintsReviewIdTokenPathParams): `/complaints/review/${string}/${string}` =>
  `/complaints/review/${encodeURIComponent(id)}/${encodeURIComponent(token)}`;

/**
 * - Xinglet: `@xing-com/crate-profile-linkedin-auth`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_DATA_IMPORTS_LINKEDIN_PATH = '/data_imports/linkedin';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_DE_PATH = '/de';

/**
 * - Xinglet: `@xing-com/crate-video-demo-videos-upload`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_DEMO_VIDEOS_UPLOAD_PATH = '/demo-videos/upload';

/**
 * - Xinglet: `@xing-com/crate-video-demo-videos-entry`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_DEMO_VIDEOS_PATH = '/demo-videos';

/**
 * - Xinglet: `@xing-com/crate-video-demo-video-lazy`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_DEMO_VIDEOS_LAZY_PATH = '/demo-videos-lazy';

export type XingDiscoverDetailActivitiesIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-discovery-detail-view`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/discover/detail-activities/:id`
 */
export const getXingDiscoverDetailActivitiesIdPath = ({
  id,
}: XingDiscoverDetailActivitiesIdPathParams): `/discover/detail-activities/${string}` =>
  `/discover/detail-activities/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-discovery-entry`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_DISCOVER_UPDATES_PATH = '/discover/updates';

/**
 * - Xinglet: `@xing-com/crate-discovery-your-posts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_DISCOVER_YOUR_POSTS_PATH = '/discover/your-posts';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_EN_PATH = '/en';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_ES_PATH = '/es';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_FR_PATH = '/fr';

/**
 * - Xinglet: `@xing-com/crate-insights-entry-logged-out`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_INSIGHTS_PATH = '/insights';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_IT_PATH = '/it';

export type XingJobsApplySlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-instant-apply`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/apply/:slug`
 */
export const getXingJobsApplySlugPath = ({
  slug,
}: XingJobsApplySlugPathParams): `/jobs/apply/${string}` =>
  `/jobs/apply/${encodeURIComponent(slug)}`;

export type XingJobsCustomApplySlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-custom-apply`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/custom-apply/:slug`
 */
export const getXingJobsCustomApplySlugPath = ({
  slug,
}: XingJobsCustomApplySlugPathParams): `/jobs/custom-apply/${string}` =>
  `/jobs/custom-apply/${encodeURIComponent(slug)}`;

export type XingJobsDacSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-job-details-reduced`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/dac/:slug`
 */
export const getXingJobsDacSlugPath = ({
  slug,
}: XingJobsDacSlugPathParams): `/jobs/dac/${string}` =>
  `/jobs/dac/${encodeURIComponent(slug)}`;

export type XingJobsDirectorySkillSkillPathParams = {
  skill: string;
};

/**
 * - Xinglet: `@xing-com/crate-master-directory-skill`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/jobs/directory/skill/:skill`
 */
export const getXingJobsDirectorySkillSkillPath = ({
  skill,
}: XingJobsDirectorySkillSkillPathParams): `/jobs/directory/skill/${string}` =>
  `/jobs/directory/skill/${encodeURIComponent(skill)}`;

export type XingJobsDirectoryLetterJobRolePathParams = {
  letter: string;
  jobRole: string;
};

/**
 * - Xinglet: `@xing-com/crate-master-directory-job-role`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/jobs/directory/:letter/:jobRole`
 */
export const getXingJobsDirectoryLetterJobRolePath = ({
  letter,
  jobRole,
}: XingJobsDirectoryLetterJobRolePathParams): `/jobs/directory/${string}/${string}` =>
  `/jobs/directory/${encodeURIComponent(letter)}/${encodeURIComponent(jobRole)}`;

export type XingJobsDirectoryLetterPathParams = {
  letter: string;
};

/**
 * - Xinglet: `@xing-com/crate-master-directory-root`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/jobs/directory/:letter`
 */
export const getXingJobsDirectoryLetterPath = ({
  letter,
}: XingJobsDirectoryLetterPathParams): `/jobs/directory/${string}` =>
  `/jobs/directory/${encodeURIComponent(letter)}`;

export type XingJobsExternalApplySlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-external-apply-logged-out`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/external-apply/:slug`
 */
export const getXingJobsExternalApplySlugPath = ({
  slug,
}: XingJobsExternalApplySlugPathParams): `/jobs/external-apply/${string}` =>
  `/jobs/external-apply/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-dream-machine-startpage`
 * - Owner: `@xing-com/crate-jobs`
 */
export const XING_JOBS_FIND_PATH = '/jobs/find';

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-my-jobs`
 * - Owner: `@xing-com/crate-jobs`
 */
export const XING_JOBS_MY_JOBS_PATH = '/jobs/my-jobs';

export type XingJobsQuickApplySlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-quick-apply`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/quick-apply/:slug`
 */
export const getXingJobsQuickApplySlugPath = ({
  slug,
}: XingJobsQuickApplySlugPathParams): `/jobs/quick-apply/${string}` =>
  `/jobs/quick-apply/${encodeURIComponent(slug)}`;

export type XingJobsSearchConfirmTokenPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search-alert-email-proxy`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/search/confirm/:token`
 */
export const getXingJobsSearchConfirmTokenPath = ({
  token,
}: XingJobsSearchConfirmTokenPathParams): `/jobs/search/confirm/${string}` =>
  `/jobs/search/confirm/${encodeURIComponent(token)}`;

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search`
 * - Owner: `@xing-com/crate-jobs`
 */
export const XING_JOBS_SEARCH_KI_PATH = '/jobs/search/ki';

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search-logged-out-legacy`
 * - Owner: `@xing-com/crate-jobs`
 */
export const XING_JOBS_SEARCH_LOGGED_OUT_LEGACY_PATH =
  '/jobs/search/logged_out_legacy';

export type XingJobsSearchUnsubscribeTokenPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search-alert-email-proxy`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/search/unsubscribe/:token`
 */
export const getXingJobsSearchUnsubscribeTokenPath = ({
  token,
}: XingJobsSearchUnsubscribeTokenPathParams): `/jobs/search/unsubscribe/${string}` =>
  `/jobs/search/unsubscribe/${encodeURIComponent(token)}`;

export type XingJobsSearchIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search-id-proxy`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/search/:id`
 */
export const getXingJobsSearchIdPath = ({
  id,
}: XingJobsSearchIdPathParams): `/jobs/search/${string}` =>
  `/jobs/search/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search`
 * - Owner: `@xing-com/crate-jobs`
 */
export const XING_JOBS_SEARCH_PATH = '/jobs/search';

export type XingJobsSkillSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/skill/:slug`
 */
export const getXingJobsSkillSlugPath = ({
  slug,
}: XingJobsSkillSlugPathParams): `/jobs/skill/${string}` =>
  `/jobs/skill/${encodeURIComponent(slug)}`;

export type XingJobsSerpsCategorySlugSerpsSubcategorySlugPathParams = {
  serpsCategorySlug: string;
  serpsSubcategorySlug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-search`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/:serpsCategorySlug/:serpsSubcategorySlug`
 */
export const getXingJobsSerpsCategorySlugSerpsSubcategorySlugPath = ({
  serpsCategorySlug,
  serpsSubcategorySlug,
}: XingJobsSerpsCategorySlugSerpsSubcategorySlugPathParams): `/jobs/${string}/${string}` =>
  `/jobs/${encodeURIComponent(serpsCategorySlug)}/${encodeURIComponent(serpsSubcategorySlug)}`;

export type XingJobsSlugContactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-job-contacts`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/:slug/contacts`
 */
export const getXingJobsSlugContactsPath = ({
  slug,
}: XingJobsSlugContactsPathParams): `/jobs/${string}/contacts` =>
  `/jobs/${encodeURIComponent(slug)}/contacts`;

export type XingJobsSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-pages-job-details`
 * - Owner: `@xing-com/crate-jobs`
 * - Path: `/jobs/:slug`
 */
export const getXingJobsSlugPath = ({
  slug,
}: XingJobsSlugPathParams): `/jobs/${string}` =>
  `/jobs/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-jobseeker-settings-visibility-blocked-companies`
 * - Owner: `@xing-com/crate-job-preferences`
 */
export const XING_JOBSEEKER_CRITERIA_VISIBILITY_BLOCKED_COMPANIES_PATH =
  '/jobseeker-criteria/visibility/blocked-companies';

/**
 * - Xinglet: `@xing-com/crate-jobseeker-settings-visibility`
 * - Owner: `@xing-com/crate-job-preferences`
 */
export const XING_JOBSEEKER_CRITERIA_VISIBILITY_PATH =
  '/jobseeker-criteria/visibility';

/**
 * - Xinglet: `@xing-com/crate-jobseeker-settings-main-entry`
 * - Owner: `@xing-com/crate-job-preferences`
 */
export const XING_JOBSEEKER_CRITERIA_PATH = '/jobseeker-criteria';

export type XingKarriereRatgeberBewerbungTopicKeyPathParams = {
  topicKey: string;
};

/**
 * - Xinglet: `@xing-com/crate-career-hub-subtopic-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/karriere-ratgeber/bewerbung/:topicKey`
 */
export const getXingKarriereRatgeberBewerbungTopicKeyPath = ({
  topicKey,
}: XingKarriereRatgeberBewerbungTopicKeyPathParams): `/karriere-ratgeber/bewerbung/${string}` =>
  `/karriere-ratgeber/bewerbung/${encodeURIComponent(topicKey)}`;

/**
 * - Xinglet: `@xing-com/crate-career-hub-bewerbung-topic-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_KARRIERE_RATGEBER_BEWERBUNG_PATH =
  '/karriere-ratgeber/bewerbung';

/**
 * - Xinglet: `@xing-com/crate-career-hub-category-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_KARRIERE_RATGEBER_BEWERBUNG_UEBERSICHT_PATH =
  '/karriere-ratgeber/bewerbung-uebersicht';

/**
 * - Xinglet: `@xing-com/crate-career-hub-glossary`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_KARRIERE_RATGEBER_THEMEN_A_BIS_Z_PATH =
  '/karriere-ratgeber/themen-a-bis-z';

export type XingKarriereRatgeberTopicKeyPathParams = {
  topicKey: string;
};

/**
 * - Xinglet: `@xing-com/crate-career-hub-topic-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/karriere-ratgeber/:topicKey`
 */
export const getXingKarriereRatgeberTopicKeyPath = ({
  topicKey,
}: XingKarriereRatgeberTopicKeyPathParams): `/karriere-ratgeber/${string}` =>
  `/karriere-ratgeber/${encodeURIComponent(topicKey)}`;

/**
 * - Xinglet: `@xing-com/crate-career-hub-main-entry`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_KARRIERE_RATGEBER_PATH = '/karriere-ratgeber';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-language-switcher`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_LANGUAGE_PATH = '/language';

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-cover-letter`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEBENSLAUF_ANSCHREIBEN_PATH = '/lebenslauf/anschreiben';

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-new`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEBENSLAUF_NEU_PATH = '/lebenslauf/neu';

export type XingLebenslaufPrintCoverLetterTokenPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-print`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/lebenslauf/print/cover_letter/:token`
 */
export const getXingLebenslaufPrintCoverLetterTokenPath = ({
  token,
}: XingLebenslaufPrintCoverLetterTokenPathParams): `/lebenslauf/print/cover_letter/${string}` =>
  `/lebenslauf/print/cover_letter/${encodeURIComponent(token)}`;

export type XingLebenslaufPrintTokenPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-print`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/lebenslauf/print/:token`
 */
export const getXingLebenslaufPrintTokenPath = ({
  token,
}: XingLebenslaufPrintTokenPathParams): `/lebenslauf/print/${string}` =>
  `/lebenslauf/print/${encodeURIComponent(token)}`;

export type XingLebenslaufRatgeberSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-article`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/lebenslauf/ratgeber/:slug`
 */
export const getXingLebenslaufRatgeberSlugPath = ({
  slug,
}: XingLebenslaufRatgeberSlugPathParams): `/lebenslauf/ratgeber/${string}` =>
  `/lebenslauf/ratgeber/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-advisory`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEBENSLAUF_RATGEBER_PATH = '/lebenslauf/ratgeber';

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-templates`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEBENSLAUF_VORLAGEN_UND_MUSTER_PATH =
  '/lebenslauf/vorlagen-und-muster';

/**
 * - Xinglet: `@xing-com/crate-lebenslauf-pages-startpage`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEBENSLAUF_PATH = '/lebenslauf';

/**
 * - Xinglet: `@xing-com/crate-legal-pages-legal-notice`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_LEGALNOTICE_PATH = '/legalnotice';

/**
 * - Xinglet: `@xing-com/crate-network-birthdays`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_BIRTHDAYS_PATH = '/network/birthdays';

/**
 * - Xinglet: `@xing-com/crate-network-contact-list`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_CONTACTLIST_PATH = '/network/contactlist';

export type XingNetworkHiringDetailsPageNamePathParams = {
  pageName: string;
};

/**
 * - Xinglet: `@xing-com/crate-network-hiring-details-modal`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/network/hiring-details/:pageName`
 */
export const getXingNetworkHiringDetailsPageNamePath = ({
  pageName,
}: XingNetworkHiringDetailsPageNamePathParams): `/network/hiring-details/${string}` =>
  `/network/hiring-details/${encodeURIComponent(pageName)}`;

/**
 * - Xinglet: `@xing-com/crate-network-recommendations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_RECOMMENDATIONS_PATH = '/network/recommendations';

/**
 * - Xinglet: `@xing-com/crate-network-recruiters-recommendations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_RECRUITERS_PATH = '/network/recruiters';

/**
 * - Xinglet: `@xing-com/crate-network-requests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_REQUESTS_SENT_PATH = '/network/requests/sent';

export type XingNetworkRequestsTokenAcceptPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-network-request-token-accept`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/network/requests/:token/accept`
 */
export const getXingNetworkRequestsTokenAcceptPath = ({
  token,
}: XingNetworkRequestsTokenAcceptPathParams): `/network/requests/${string}/accept` =>
  `/network/requests/${encodeURIComponent(token)}/accept`;

export type XingNetworkRequestsTokenSendPathParams = {
  token: string;
};

/**
 * - Xinglet: `@xing-com/crate-network-request-token-send`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/network/requests/:token/send`
 */
export const getXingNetworkRequestsTokenSendPath = ({
  token,
}: XingNetworkRequestsTokenSendPathParams): `/network/requests/${string}/send` =>
  `/network/requests/${encodeURIComponent(token)}/send`;

/**
 * - Xinglet: `@xing-com/crate-network-requests`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_REQUESTS_PATH = '/network/requests';

/**
 * - Xinglet: `@xing-com/crate-network-switch`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NETWORK_PATH = '/network';

/**
 * - Xinglet: `@xing-com/crate-articles-demo`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NEWS_ARTICLE_DEMO_PATH = '/news/article/demo';

/**
 * - Xinglet: `@xing-com/crate-articles-editor`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NEWS_ARTICLE_EDIT_NEW_PATH = '/news/article/edit/new';

/**
 * - Xinglet: `@xing-com/crate-articles-editor`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NEWS_ARTICLE_INSIDER_EDIT_NEW_PATH =
  '/news/article/insider/edit/new';

export type XingNewsArticleInsiderPageIdEditNewPathParams = {
  page_id: string;
};

/**
 * - Xinglet: `@xing-com/crate-articles-editor`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/article/insider/:page_id/edit/new`
 */
export const getXingNewsArticleInsiderPageIdEditNewPath = ({
  page_id,
}: XingNewsArticleInsiderPageIdEditNewPathParams): `/news/article/insider/${string}/edit/new` =>
  `/news/article/insider/${encodeURIComponent(page_id)}/edit/new`;

export type XingNewsArticlePagePageIdEditNewPathParams = {
  page_id: string;
};

/**
 * - Xinglet: `@xing-com/crate-articles-editor`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/article/page/:page_id/edit/new`
 */
export const getXingNewsArticlePagePageIdEditNewPath = ({
  page_id,
}: XingNewsArticlePagePageIdEditNewPathParams): `/news/article/page/${string}/edit/new` =>
  `/news/article/page/${encodeURIComponent(page_id)}/edit/new`;

export type XingNewsArticleArticleIdEditPathParams = {
  article_id: string;
};

/**
 * - Xinglet: `@xing-com/crate-articles-editor`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/article/:article_id/edit`
 */
export const getXingNewsArticleArticleIdEditPath = ({
  article_id,
}: XingNewsArticleArticleIdEditPathParams): `/news/article/${string}/edit` =>
  `/news/article/${encodeURIComponent(article_id)}/edit`;

export type XingNewsArticleIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-articles-viewer`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/article/:id`
 */
export const getXingNewsArticleIdPath = ({
  id,
}: XingNewsArticleIdPathParams): `/news/article/${string}` =>
  `/news/article/${encodeURIComponent(id)}`;

export type XingNewsInsiderCollectionSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-insider-redirect`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/insider-collection/:slug`
 */
export const getXingNewsInsiderCollectionSlugPath = ({
  slug,
}: XingNewsInsiderCollectionSlugPathParams): `/news/insider-collection/${string}` =>
  `/news/insider-collection/${encodeURIComponent(slug)}`;

export type XingNewsInsiderCollectionUserIdActivationPathParams = {
  userId: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-insider-activation`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/insider-collection/:userId/activation`
 */
export const getXingNewsInsiderCollectionUserIdActivationPath = ({
  userId,
}: XingNewsInsiderCollectionUserIdActivationPathParams): `/news/insider-collection/${string}/activation` =>
  `/news/insider-collection/${encodeURIComponent(userId)}/activation`;

export type XingNewsRecommendationsTypePathParams = {
  type: string;
};

/**
 * - Xinglet: `@xing-com/crate-following-recommendation-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/news/recommendations/:type`
 */
export const getXingNewsRecommendationsTypePath = ({
  type,
}: XingNewsRecommendationsTypePathParams): `/news/recommendations/${string}` =>
  `/news/recommendations/${encodeURIComponent(type)}`;

/**
 * - Xinglet: `@xing-com/crate-following-recommendations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NEWS_SELECTIONS_FOLLOWING_RECOMMENDATIONS_PATH =
  '/news/selections/following/recommendations';

/**
 * - Xinglet: `@xing-com/crate-following-following-list`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NEWS_SELECTIONS_FOLLOWING_PATH = '/news/selections/following';

/**
 * - Xinglet: `@xing-com/crate-notification-center-pages-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NOTIFICATIONS_CONTACTS_PATH = '/notifications/contacts';

/**
 * - Xinglet: `@xing-com/crate-notifications-email-unsubscribe`
 * - Owner: `@xing-com/crate-messenger`
 */
export const XING_NOTIFICATIONS_EMAIL_UNSUBSCRIBE_PATH =
  '/notifications/email/unsubscribe';

/**
 * - Xinglet: `@xing-com/crate-notification-center-pages-home`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_NOTIFICATIONS_PATH = '/notifications';

/**
 * - Xinglet: `@xing-com/crate-onboarding-next-controller`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_ONBOARDING_PATH = '/onboarding';

/**
 * - Xinglet: `@xing-com/crate-entity-pages-page-creation`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PAGES_NEW_COMPANY_PATH = '/pages/new/company';

export type XingPagesWebviewSlugAboutUsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-about-us`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/about_us/:param`
 */
export const getXingPagesWebviewSlugAboutUsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugAboutUsParamPathParams): `/pages/webview/${string}/about_us/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/about_us/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugAboutUsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-about-us`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/about_us`
 */
export const getXingPagesWebviewSlugAboutUsPath = ({
  slug,
}: XingPagesWebviewSlugAboutUsPathParams): `/pages/webview/${string}/about_us` =>
  `/pages/webview/${encodeURIComponent(slug)}/about_us`;

export type XingPagesWebviewSlugContactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/contacts/:param`
 */
export const getXingPagesWebviewSlugContactsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugContactsParamPathParams): `/pages/webview/${string}/contacts/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/contacts/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugContactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/contacts`
 */
export const getXingPagesWebviewSlugContactsPath = ({
  slug,
}: XingPagesWebviewSlugContactsPathParams): `/pages/webview/${string}/contacts` =>
  `/pages/webview/${encodeURIComponent(slug)}/contacts`;

export type XingPagesWebviewSlugEditAboutEditViewParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-edit-view`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutEditView/:param`
 */
export const getXingPagesWebviewSlugEditAboutEditViewParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditAboutEditViewParamPathParams): `/pages/webview/${string}/edit/aboutEditView/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutEditView/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditAboutEditViewPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-edit-view`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutEditView`
 */
export const getXingPagesWebviewSlugEditAboutEditViewPath = ({
  slug,
}: XingPagesWebviewSlugEditAboutEditViewPathParams): `/pages/webview/${string}/edit/aboutEditView` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutEditView`;

export type XingPagesWebviewSlugEditAboutUsDescriptionParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-description`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutUsDescription/:param`
 */
export const getXingPagesWebviewSlugEditAboutUsDescriptionParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditAboutUsDescriptionParamPathParams): `/pages/webview/${string}/edit/aboutUsDescription/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutUsDescription/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditAboutUsDescriptionPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-description`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutUsDescription`
 */
export const getXingPagesWebviewSlugEditAboutUsDescriptionPath = ({
  slug,
}: XingPagesWebviewSlugEditAboutUsDescriptionPathParams): `/pages/webview/${string}/edit/aboutUsDescription` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutUsDescription`;

export type XingPagesWebviewSlugEditAboutUsSummaryParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-summary`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutUsSummary/:param`
 */
export const getXingPagesWebviewSlugEditAboutUsSummaryParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditAboutUsSummaryParamPathParams): `/pages/webview/${string}/edit/aboutUsSummary/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutUsSummary/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditAboutUsSummaryPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-summary`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/aboutUsSummary`
 */
export const getXingPagesWebviewSlugEditAboutUsSummaryPath = ({
  slug,
}: XingPagesWebviewSlugEditAboutUsSummaryPathParams): `/pages/webview/${string}/edit/aboutUsSummary` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/aboutUsSummary`;

export type XingPagesWebviewSlugEditAffiliatesParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-affiliates`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/affiliates/:param`
 */
export const getXingPagesWebviewSlugEditAffiliatesParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditAffiliatesParamPathParams): `/pages/webview/${string}/edit/affiliates/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/affiliates/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditAffiliatesPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-affiliates`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/affiliates`
 */
export const getXingPagesWebviewSlugEditAffiliatesPath = ({
  slug,
}: XingPagesWebviewSlugEditAffiliatesPathParams): `/pages/webview/${string}/edit/affiliates` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/affiliates`;

export type XingPagesWebviewSlugEditContactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/contacts/:param`
 */
export const getXingPagesWebviewSlugEditContactsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditContactsParamPathParams): `/pages/webview/${string}/edit/contacts/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/contacts/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditContactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/contacts`
 */
export const getXingPagesWebviewSlugEditContactsPath = ({
  slug,
}: XingPagesWebviewSlugEditContactsPathParams): `/pages/webview/${string}/edit/contacts` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/contacts`;

export type XingPagesWebviewSlugEditDocumentsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-documents`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/documents/:param`
 */
export const getXingPagesWebviewSlugEditDocumentsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditDocumentsParamPathParams): `/pages/webview/${string}/edit/documents/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/documents/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditDocumentsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-documents`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/documents`
 */
export const getXingPagesWebviewSlugEditDocumentsPath = ({
  slug,
}: XingPagesWebviewSlugEditDocumentsPathParams): `/pages/webview/${string}/edit/documents` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/documents`;

export type XingPagesWebviewSlugEditFactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-facts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/facts/:param`
 */
export const getXingPagesWebviewSlugEditFactsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditFactsParamPathParams): `/pages/webview/${string}/edit/facts/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/facts/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditFactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-facts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/facts`
 */
export const getXingPagesWebviewSlugEditFactsPath = ({
  slug,
}: XingPagesWebviewSlugEditFactsPathParams): `/pages/webview/${string}/edit/facts` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/facts`;

export type XingPagesWebviewSlugEditGalleryParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-gallery`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/gallery/:param`
 */
export const getXingPagesWebviewSlugEditGalleryParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditGalleryParamPathParams): `/pages/webview/${string}/edit/gallery/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/gallery/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditGalleryPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-gallery`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/gallery`
 */
export const getXingPagesWebviewSlugEditGalleryPath = ({
  slug,
}: XingPagesWebviewSlugEditGalleryPathParams): `/pages/webview/${string}/edit/gallery` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/gallery`;

export type XingPagesWebviewSlugEditLocationsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-locations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/locations/:param`
 */
export const getXingPagesWebviewSlugEditLocationsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditLocationsParamPathParams): `/pages/webview/${string}/edit/locations/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/locations/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditLocationsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-locations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/locations`
 */
export const getXingPagesWebviewSlugEditLocationsPath = ({
  slug,
}: XingPagesWebviewSlugEditLocationsPathParams): `/pages/webview/${string}/edit/locations` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/locations`;

export type XingPagesWebviewSlugEditPageInfoParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-page-info`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/pageInfo/:param`
 */
export const getXingPagesWebviewSlugEditPageInfoParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditPageInfoParamPathParams): `/pages/webview/${string}/edit/pageInfo/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/pageInfo/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditPageInfoPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-page-info`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/pageInfo`
 */
export const getXingPagesWebviewSlugEditPageInfoPath = ({
  slug,
}: XingPagesWebviewSlugEditPageInfoPathParams): `/pages/webview/${string}/edit/pageInfo` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/pageInfo`;

export type XingPagesWebviewSlugEditYourTopicsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-your-topics`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/yourTopics/:param`
 */
export const getXingPagesWebviewSlugEditYourTopicsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEditYourTopicsParamPathParams): `/pages/webview/${string}/edit/yourTopics/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/yourTopics/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEditYourTopicsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-your-topics`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/edit/yourTopics`
 */
export const getXingPagesWebviewSlugEditYourTopicsPath = ({
  slug,
}: XingPagesWebviewSlugEditYourTopicsPathParams): `/pages/webview/${string}/edit/yourTopics` =>
  `/pages/webview/${encodeURIComponent(slug)}/edit/yourTopics`;

export type XingPagesWebviewSlugEmployeesParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-employees`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/employees/:param`
 */
export const getXingPagesWebviewSlugEmployeesParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugEmployeesParamPathParams): `/pages/webview/${string}/employees/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/employees/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugEmployeesPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-employees`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/employees`
 */
export const getXingPagesWebviewSlugEmployeesPath = ({
  slug,
}: XingPagesWebviewSlugEmployeesPathParams): `/pages/webview/${string}/employees` =>
  `/pages/webview/${encodeURIComponent(slug)}/employees`;

export type XingPagesWebviewSlugJobsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-jobs`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/jobs/:param`
 */
export const getXingPagesWebviewSlugJobsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugJobsParamPathParams): `/pages/webview/${string}/jobs/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/jobs/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugJobsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-jobs`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/jobs`
 */
export const getXingPagesWebviewSlugJobsPath = ({
  slug,
}: XingPagesWebviewSlugJobsPathParams): `/pages/webview/${string}/jobs` =>
  `/pages/webview/${encodeURIComponent(slug)}/jobs`;

export type XingPagesWebviewSlugNewsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-news`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/news/:param`
 */
export const getXingPagesWebviewSlugNewsParamPath = ({
  slug,
  param,
}: XingPagesWebviewSlugNewsParamPathParams): `/pages/webview/${string}/news/${string}` =>
  `/pages/webview/${encodeURIComponent(slug)}/news/${encodeURIComponent(param)}`;

export type XingPagesWebviewSlugNewsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-news`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/webview/:slug/news`
 */
export const getXingPagesWebviewSlugNewsPath = ({
  slug,
}: XingPagesWebviewSlugNewsPathParams): `/pages/webview/${string}/news` =>
  `/pages/webview/${encodeURIComponent(slug)}/news`;

export type XingPagesSlugAboutUsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-about-us`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/about_us/:param`
 */
export const getXingPagesSlugAboutUsParamPath = ({
  slug,
  param,
}: XingPagesSlugAboutUsParamPathParams): `/pages/${string}/about_us/${string}` =>
  `/pages/${encodeURIComponent(slug)}/about_us/${encodeURIComponent(param)}`;

export type XingPagesSlugAboutUsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-about-us`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/about_us`
 */
export const getXingPagesSlugAboutUsPath = ({
  slug,
}: XingPagesSlugAboutUsPathParams): `/pages/${string}/about_us` =>
  `/pages/${encodeURIComponent(slug)}/about_us`;

export type XingPagesSlugContactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/contacts/:param`
 */
export const getXingPagesSlugContactsParamPath = ({
  slug,
  param,
}: XingPagesSlugContactsParamPathParams): `/pages/${string}/contacts/${string}` =>
  `/pages/${encodeURIComponent(slug)}/contacts/${encodeURIComponent(param)}`;

export type XingPagesSlugContactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/contacts`
 */
export const getXingPagesSlugContactsPath = ({
  slug,
}: XingPagesSlugContactsPathParams): `/pages/${string}/contacts` =>
  `/pages/${encodeURIComponent(slug)}/contacts`;

export type XingPagesSlugEditAboutEditViewParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-edit-view`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutEditView/:param`
 */
export const getXingPagesSlugEditAboutEditViewParamPath = ({
  slug,
  param,
}: XingPagesSlugEditAboutEditViewParamPathParams): `/pages/${string}/edit/aboutEditView/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutEditView/${encodeURIComponent(param)}`;

export type XingPagesSlugEditAboutEditViewPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-edit-view`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutEditView`
 */
export const getXingPagesSlugEditAboutEditViewPath = ({
  slug,
}: XingPagesSlugEditAboutEditViewPathParams): `/pages/${string}/edit/aboutEditView` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutEditView`;

export type XingPagesSlugEditAboutUsDescriptionParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-description`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutUsDescription/:param`
 */
export const getXingPagesSlugEditAboutUsDescriptionParamPath = ({
  slug,
  param,
}: XingPagesSlugEditAboutUsDescriptionParamPathParams): `/pages/${string}/edit/aboutUsDescription/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutUsDescription/${encodeURIComponent(param)}`;

export type XingPagesSlugEditAboutUsDescriptionPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-description`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutUsDescription`
 */
export const getXingPagesSlugEditAboutUsDescriptionPath = ({
  slug,
}: XingPagesSlugEditAboutUsDescriptionPathParams): `/pages/${string}/edit/aboutUsDescription` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutUsDescription`;

export type XingPagesSlugEditAboutUsSummaryParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-summary`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutUsSummary/:param`
 */
export const getXingPagesSlugEditAboutUsSummaryParamPath = ({
  slug,
  param,
}: XingPagesSlugEditAboutUsSummaryParamPathParams): `/pages/${string}/edit/aboutUsSummary/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutUsSummary/${encodeURIComponent(param)}`;

export type XingPagesSlugEditAboutUsSummaryPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-about-us-summary`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/aboutUsSummary`
 */
export const getXingPagesSlugEditAboutUsSummaryPath = ({
  slug,
}: XingPagesSlugEditAboutUsSummaryPathParams): `/pages/${string}/edit/aboutUsSummary` =>
  `/pages/${encodeURIComponent(slug)}/edit/aboutUsSummary`;

export type XingPagesSlugEditAffiliatesParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-affiliates`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/affiliates/:param`
 */
export const getXingPagesSlugEditAffiliatesParamPath = ({
  slug,
  param,
}: XingPagesSlugEditAffiliatesParamPathParams): `/pages/${string}/edit/affiliates/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/affiliates/${encodeURIComponent(param)}`;

export type XingPagesSlugEditAffiliatesPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-affiliates`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/affiliates`
 */
export const getXingPagesSlugEditAffiliatesPath = ({
  slug,
}: XingPagesSlugEditAffiliatesPathParams): `/pages/${string}/edit/affiliates` =>
  `/pages/${encodeURIComponent(slug)}/edit/affiliates`;

export type XingPagesSlugEditContactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/contacts/:param`
 */
export const getXingPagesSlugEditContactsParamPath = ({
  slug,
  param,
}: XingPagesSlugEditContactsParamPathParams): `/pages/${string}/edit/contacts/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/contacts/${encodeURIComponent(param)}`;

export type XingPagesSlugEditContactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/contacts`
 */
export const getXingPagesSlugEditContactsPath = ({
  slug,
}: XingPagesSlugEditContactsPathParams): `/pages/${string}/edit/contacts` =>
  `/pages/${encodeURIComponent(slug)}/edit/contacts`;

export type XingPagesSlugEditDocumentsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-documents`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/documents/:param`
 */
export const getXingPagesSlugEditDocumentsParamPath = ({
  slug,
  param,
}: XingPagesSlugEditDocumentsParamPathParams): `/pages/${string}/edit/documents/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/documents/${encodeURIComponent(param)}`;

export type XingPagesSlugEditDocumentsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-documents`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/documents`
 */
export const getXingPagesSlugEditDocumentsPath = ({
  slug,
}: XingPagesSlugEditDocumentsPathParams): `/pages/${string}/edit/documents` =>
  `/pages/${encodeURIComponent(slug)}/edit/documents`;

export type XingPagesSlugEditFactsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-facts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/facts/:param`
 */
export const getXingPagesSlugEditFactsParamPath = ({
  slug,
  param,
}: XingPagesSlugEditFactsParamPathParams): `/pages/${string}/edit/facts/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/facts/${encodeURIComponent(param)}`;

export type XingPagesSlugEditFactsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-facts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/facts`
 */
export const getXingPagesSlugEditFactsPath = ({
  slug,
}: XingPagesSlugEditFactsPathParams): `/pages/${string}/edit/facts` =>
  `/pages/${encodeURIComponent(slug)}/edit/facts`;

export type XingPagesSlugEditGalleryParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-gallery`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/gallery/:param`
 */
export const getXingPagesSlugEditGalleryParamPath = ({
  slug,
  param,
}: XingPagesSlugEditGalleryParamPathParams): `/pages/${string}/edit/gallery/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/gallery/${encodeURIComponent(param)}`;

export type XingPagesSlugEditGalleryPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-gallery`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/gallery`
 */
export const getXingPagesSlugEditGalleryPath = ({
  slug,
}: XingPagesSlugEditGalleryPathParams): `/pages/${string}/edit/gallery` =>
  `/pages/${encodeURIComponent(slug)}/edit/gallery`;

export type XingPagesSlugEditLocationsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-locations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/locations/:param`
 */
export const getXingPagesSlugEditLocationsParamPath = ({
  slug,
  param,
}: XingPagesSlugEditLocationsParamPathParams): `/pages/${string}/edit/locations/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/locations/${encodeURIComponent(param)}`;

export type XingPagesSlugEditLocationsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-locations`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/locations`
 */
export const getXingPagesSlugEditLocationsPath = ({
  slug,
}: XingPagesSlugEditLocationsPathParams): `/pages/${string}/edit/locations` =>
  `/pages/${encodeURIComponent(slug)}/edit/locations`;

export type XingPagesSlugEditPageInfoParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-page-info`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/pageInfo/:param`
 */
export const getXingPagesSlugEditPageInfoParamPath = ({
  slug,
  param,
}: XingPagesSlugEditPageInfoParamPathParams): `/pages/${string}/edit/pageInfo/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/pageInfo/${encodeURIComponent(param)}`;

export type XingPagesSlugEditPageInfoPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-page-info`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/pageInfo`
 */
export const getXingPagesSlugEditPageInfoPath = ({
  slug,
}: XingPagesSlugEditPageInfoPathParams): `/pages/${string}/edit/pageInfo` =>
  `/pages/${encodeURIComponent(slug)}/edit/pageInfo`;

export type XingPagesSlugEditYourTopicsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-your-topics`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/yourTopics/:param`
 */
export const getXingPagesSlugEditYourTopicsParamPath = ({
  slug,
  param,
}: XingPagesSlugEditYourTopicsParamPathParams): `/pages/${string}/edit/yourTopics/${string}` =>
  `/pages/${encodeURIComponent(slug)}/edit/yourTopics/${encodeURIComponent(param)}`;

export type XingPagesSlugEditYourTopicsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-edit-page-your-topics`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/edit/yourTopics`
 */
export const getXingPagesSlugEditYourTopicsPath = ({
  slug,
}: XingPagesSlugEditYourTopicsPathParams): `/pages/${string}/edit/yourTopics` =>
  `/pages/${encodeURIComponent(slug)}/edit/yourTopics`;

export type XingPagesSlugEmployeesParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-employees`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/employees/:param`
 */
export const getXingPagesSlugEmployeesParamPath = ({
  slug,
  param,
}: XingPagesSlugEmployeesParamPathParams): `/pages/${string}/employees/${string}` =>
  `/pages/${encodeURIComponent(slug)}/employees/${encodeURIComponent(param)}`;

export type XingPagesSlugEmployeesPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-employees`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/employees`
 */
export const getXingPagesSlugEmployeesPath = ({
  slug,
}: XingPagesSlugEmployeesPathParams): `/pages/${string}/employees` =>
  `/pages/${encodeURIComponent(slug)}/employees`;

export type XingPagesSlugJobsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-jobs`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/jobs/:param`
 */
export const getXingPagesSlugJobsParamPath = ({
  slug,
  param,
}: XingPagesSlugJobsParamPathParams): `/pages/${string}/jobs/${string}` =>
  `/pages/${encodeURIComponent(slug)}/jobs/${encodeURIComponent(param)}`;

export type XingPagesSlugJobsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-jobs`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/jobs`
 */
export const getXingPagesSlugJobsPath = ({
  slug,
}: XingPagesSlugJobsPathParams): `/pages/${string}/jobs` =>
  `/pages/${encodeURIComponent(slug)}/jobs`;

export type XingPagesSlugNewsParamPathParams = {
  slug: string;
  param: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-news`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/news/:param`
 */
export const getXingPagesSlugNewsParamPath = ({
  slug,
  param,
}: XingPagesSlugNewsParamPathParams): `/pages/${string}/news/${string}` =>
  `/pages/${encodeURIComponent(slug)}/news/${encodeURIComponent(param)}`;

export type XingPagesSlugNewsPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-subpage-news`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug/news`
 */
export const getXingPagesSlugNewsPath = ({
  slug,
}: XingPagesSlugNewsPathParams): `/pages/${string}/news` =>
  `/pages/${encodeURIComponent(slug)}/news`;

export type XingPagesSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-entity-pages-overview`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/pages/:slug`
 */
export const getXingPagesSlugPath = ({
  slug,
}: XingPagesSlugPathParams): `/pages/${string}` =>
  `/pages/${encodeURIComponent(slug)}`;

export type XingPeopleCitiesCountryCityPagesLetterPageLevelPagePathParams = {
  country: string;
  city: string;
  letter: string;
  pageLevel: string;
  page: string;
};

/**
 * - Xinglet: `@xing-com/crate-people-directory-chunk-page-by-city`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/people/cities/:country/:city/pages/:letter/:pageLevel/:page`
 */
export const getXingPeopleCitiesCountryCityPagesLetterPageLevelPagePath = ({
  country,
  city,
  letter,
  pageLevel,
  page,
}: XingPeopleCitiesCountryCityPagesLetterPageLevelPagePathParams): `/people/cities/${string}/${string}/pages/${string}/${string}/${string}` =>
  `/people/cities/${encodeURIComponent(country)}/${encodeURIComponent(city)}/pages/${encodeURIComponent(letter)}/${encodeURIComponent(pageLevel)}/${encodeURIComponent(page)}`;

export type XingPeopleCitiesCountryCityCitySlugOrLetterPathParams = {
  country: string;
  city: string;
  citySlugOrLetter: string;
};

/**
 * - Xinglet: `@xing-com/crate-people-directory-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/people/cities/:country/:city/:citySlugOrLetter`
 */
export const getXingPeopleCitiesCountryCityCitySlugOrLetterPath = ({
  country,
  city,
  citySlugOrLetter,
}: XingPeopleCitiesCountryCityCitySlugOrLetterPathParams): `/people/cities/${string}/${string}/${string}` =>
  `/people/cities/${encodeURIComponent(country)}/${encodeURIComponent(city)}/${encodeURIComponent(citySlugOrLetter)}`;

export type XingPeopleCitiesCountryCityPathParams = {
  country: string;
  city: string;
};

/**
 * - Xinglet: `@xing-com/crate-people-directory-city-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/people/cities/:country/:city`
 */
export const getXingPeopleCitiesCountryCityPath = ({
  country,
  city,
}: XingPeopleCitiesCountryCityPathParams): `/people/cities/${string}/${string}` =>
  `/people/cities/${encodeURIComponent(country)}/${encodeURIComponent(city)}`;

/**
 * - Xinglet: `@xing-com/crate-people-directory-cities-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_PEOPLE_CITIES_PATH = '/people/cities';

export type XingPeoplePagesLetterPageLevelPagePathParams = {
  letter: string;
  pageLevel: string;
  page: string;
};

/**
 * - Xinglet: `@xing-com/crate-people-directory-chunk-page-by-username`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/people/pages/:letter/:pageLevel/:page`
 */
export const getXingPeoplePagesLetterPageLevelPagePath = ({
  letter,
  pageLevel,
  page,
}: XingPeoplePagesLetterPageLevelPagePathParams): `/people/pages/${string}/${string}/${string}` =>
  `/people/pages/${encodeURIComponent(letter)}/${encodeURIComponent(pageLevel)}/${encodeURIComponent(page)}`;

export type XingPeopleSlugOrLetterPathParams = {
  slugOrLetter: string;
};

/**
 * - Xinglet: `@xing-com/crate-people-directory-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 * - Path: `/people/:slugOrLetter`
 */
export const getXingPeopleSlugOrLetterPath = ({
  slugOrLetter,
}: XingPeopleSlugOrLetterPathParams): `/people/${string}` =>
  `/people/${encodeURIComponent(slugOrLetter)}`;

/**
 * - Xinglet: `@xing-com/crate-people-directory-start-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_PEOPLE_PATH = '/people';

/**
 * - Xinglet: `@xing-com/crate-premium-features-overview`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PREMIUM_FEATURES_PATH = '/premium/features';

export type XingPremiumPartnersSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-premium-perk-details`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/premium/partners/:slug`
 */
export const getXingPremiumPartnersSlugPath = ({
  slug,
}: XingPremiumPartnersSlugPathParams): `/premium/partners/${string}` =>
  `/premium/partners/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-premium-perks-list`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PREMIUM_PARTNERS_PATH = '/premium/partners';

/**
 * - Xinglet: `@xing-com/crate-premium-voucher`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PREMIUM_VOUCHER_PATH = '/premium/voucher';

/**
 * - Xinglet: `@xing-com/crate-premium-voucher`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PREMIUM_VOUCHER_SPECIAL_PATH = '/premium/voucher-special';

/**
 * - Xinglet: `@xing-com/crate-premium-your-premium`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PREMIUM_PATH = '/premium';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-about-me-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_ABOUT_ME_EDIT_PATH =
  '/profile/my_profile/about-me/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-cv-profile-update`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_CV_UPDATE_EDIT_PATH =
  '/profile/my_profile/cv-update/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-documents-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_DOCUMENTS_EDIT_PATH =
  '/profile/my_profile/documents/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-hiring-edit-mode`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROFILE_MY_PROFILE_HIRING_DETAILS_EDIT_PATH =
  '/profile/my_profile/hiring-details/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-interests-and-hobbies-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_INTERESTS_EDIT_PATH =
  '/profile/my_profile/interests/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-languages-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_LANGUAGES_EDIT_PATH =
  '/profile/my_profile/languages/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-legal-notice-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_LEGAL_INFORMATION_EDIT_PATH =
  '/profile/my_profile/legal-information/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-visibility-settings-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_MODULE_STORE_EDIT_PATH =
  '/profile/my_profile/module-store/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-personal-details-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_PERSONAL_DETAILS_EDIT_PATH =
  '/profile/my_profile/personal-details/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-skills-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_SKILLS_ADD_PATH =
  '/profile/my_profile/skills/add';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-skills-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_SKILLS_EDIT_PATH =
  '/profile/my_profile/skills/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-skills-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_SKILLS_PERFORMANCE_PATH =
  '/profile/my_profile/skills/performance';

export type XingProfileMyProfileTimelineAddOccupationTypePathParams = {
  occupationType: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-timeline-edit-mode-add-or-edit-entry`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/my_profile/timeline/add/:occupationType`
 */
export const getXingProfileMyProfileTimelineAddOccupationTypePath = ({
  occupationType,
}: XingProfileMyProfileTimelineAddOccupationTypePathParams): `/profile/my_profile/timeline/add/${string}` =>
  `/profile/my_profile/timeline/add/${encodeURIComponent(occupationType)}`;

/**
 * - Xinglet: `@xing-com/crate-profile-modules-timeline-edit-mode-add`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_TIMELINE_ADD_PATH =
  '/profile/my_profile/timeline/add';

export type XingProfileMyProfileTimelineEditUrnPathParams = {
  urn: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-timeline-edit-mode-add-or-edit-entry`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/my_profile/timeline/edit/:urn`
 */
export const getXingProfileMyProfileTimelineEditUrnPath = ({
  urn,
}: XingProfileMyProfileTimelineEditUrnPathParams): `/profile/my_profile/timeline/edit/${string}` =>
  `/profile/my_profile/timeline/edit/${encodeURIComponent(urn)}`;

export type XingProfileMyProfileTimelineShowProfileIdUrnPathParams = {
  profileId: string;
  urn: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-timeline-show-mode`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/my_profile/timeline/show/:profileId/:urn`
 */
export const getXingProfileMyProfileTimelineShowProfileIdUrnPath = ({
  profileId,
  urn,
}: XingProfileMyProfileTimelineShowProfileIdUrnPathParams): `/profile/my_profile/timeline/show/${string}/${string}` =>
  `/profile/my_profile/timeline/show/${encodeURIComponent(profileId)}/${encodeURIComponent(urn)}`;

/**
 * - Xinglet: `@xing-com/crate-profile-modules-work-eligibility-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_WORK_ELIGIBILITY_EDIT_PATH =
  '/profile/my_profile/work-eligibility/edit';

export type XingProfileMyProfileXingIdContactDetailsEditTabPathParams = {
  tab: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-contact-details-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/my_profile/xing-id/contact-details/edit/:tab`
 */
export const getXingProfileMyProfileXingIdContactDetailsEditTabPath = ({
  tab,
}: XingProfileMyProfileXingIdContactDetailsEditTabPathParams): `/profile/my_profile/xing-id/contact-details/edit/${string}` =>
  `/profile/my_profile/xing-id/contact-details/edit/${encodeURIComponent(tab)}`;

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-cover-image-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_XING_ID_COVER_IMAGE_EDIT_PATH =
  '/profile/my_profile/xing-id/cover-image/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-occupations-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_XING_ID_OCCUPATIONS_EDIT_PATH =
  '/profile/my_profile/xing-id/occupations/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-user-profile-image-delete-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_XING_ID_PROFILE_IMAGE_DELETE_PATH =
  '/profile/my_profile/xing-id/profile-image/delete';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-user-profile-image-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_XING_ID_PROFILE_IMAGE_EDIT_PATH =
  '/profile/my_profile/xing-id/profile-image/edit';

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-status-edit-mode`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_MY_PROFILE_XING_ID_STATUS_MESSAGE_EDIT_PATH =
  '/profile/my_profile/xing-id/status-message/edit';

export type XingProfilePageNameTabPathParams = {
  pageName: string;
  tab: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-switch`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/:pageName/:tab`
 */
export const getXingProfilePageNameTabPath = ({
  pageName,
  tab,
}: XingProfilePageNameTabPathParams): `/profile/${string}/${string}` =>
  `/profile/${encodeURIComponent(pageName)}/${encodeURIComponent(tab)}`;

export type XingProfilePageNamePathParams = {
  pageName: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-switch`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/:pageName`
 */
export const getXingProfilePageNamePath = ({
  pageName,
}: XingProfilePageNamePathParams): `/profile/${string}` =>
  `/profile/${encodeURIComponent(pageName)}`;

export type XingProfileProfileIdLegalInformationShowPathParams = {
  profileId: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-legal-notice-show-mode`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/:profileId/legal-information/show`
 */
export const getXingProfileProfileIdLegalInformationShowPath = ({
  profileId,
}: XingProfileProfileIdLegalInformationShowPathParams): `/profile/${string}/legal-information/show` =>
  `/profile/${encodeURIComponent(profileId)}/legal-information/show`;

export type XingProfileProfileIdXingIdContactDetailsPathParams = {
  profileId: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-modules-business-card-contact-details-view-mode`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/profile/:profileId/xing-id/contact-details`
 */
export const getXingProfileProfileIdXingIdContactDetailsPath = ({
  profileId,
}: XingProfileProfileIdXingIdContactDetailsPathParams): `/profile/${string}/xing-id/contact-details` =>
  `/profile/${encodeURIComponent(profileId)}/xing-id/contact-details`;

/**
 * - Xinglet: `@xing-com/crate-profile-switch`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_PATH = '/profile';

/**
 * - Xinglet: `@xing-com/crate-profile-preview`
 * - Owner: `@xing-com/crate-profile`
 */
export const XING_PROFILE_PREVIEW_PATH = '/profile-preview';

export type XingProfileVisitsSharedContactsIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-profile-visits-shared-contacts`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/profile-visits/shared-contacts/:id`
 */
export const getXingProfileVisitsSharedContactsIdPath = ({
  id,
}: XingProfileVisitsSharedContactsIdPathParams): `/profile-visits/shared-contacts/${string}` =>
  `/profile-visits/shared-contacts/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-profile-visits-vomp`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROFILE_VISITS_PATH = '/profile-visits';

/**
 * - Xinglet: `@xing-com/crate-projobs-documents`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_DOCUMENTS_PATH = '/projobs/documents';

/**
 * - Xinglet: `@xing-com/crate-projobs-features`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_FEATURES_PATH = '/projobs/features';

/**
 * - Xinglet: `@xing-com/crate-projobs-guidance`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_GUIDE_PATH = '/projobs/guide';

export type XingProjobsPartnersSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-projobs-perk-details`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/projobs/partners/:slug`
 */
export const getXingProjobsPartnersSlugPath = ({
  slug,
}: XingProjobsPartnersSlugPathParams): `/projobs/partners/${string}` =>
  `/projobs/partners/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-projobs-perks`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_PARTNERS_PATH = '/projobs/partners';

/**
 * - Xinglet: `@xing-com/crate-projobs-profile`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_PROFILE_PATH = '/projobs/profile';

/**
 * - Xinglet: `@xing-com/crate-projobs-your-projobs`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PROJOBS_PATH = '/projobs';

export type XingPurchaseAdminCampaignPreviewCampaignIdentifierPathParams = {
  campaignIdentifier: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-campaign-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/admin/campaign-preview/:campaignIdentifier`
 */
export const getXingPurchaseAdminCampaignPreviewCampaignIdentifierPath = ({
  campaignIdentifier,
}: XingPurchaseAdminCampaignPreviewCampaignIdentifierPathParams): `/purchase/admin/campaign-preview/${string}` =>
  `/purchase/admin/campaign-preview/${encodeURIComponent(campaignIdentifier)}`;

export type XingPurchaseCancellationProductPathParams = {
  product: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-cancellation-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/cancellation/:product`
 */
export const getXingPurchaseCancellationProductPath = ({
  product,
}: XingPurchaseCancellationProductPathParams): `/purchase/cancellation/${string}` =>
  `/purchase/cancellation/${encodeURIComponent(product)}`;

export type XingPurchaseCheckoutContractIdPathParams = {
  contractId: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-checkout-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/checkout/:contractId`
 */
export const getXingPurchaseCheckoutContractIdPath = ({
  contractId,
}: XingPurchaseCheckoutContractIdPathParams): `/purchase/checkout/${string}` =>
  `/purchase/checkout/${encodeURIComponent(contractId)}`;

export type XingPurchaseCheckoutProductContractIdCampaignIdentifierCampaignTypePathParams =
  {
    product: string;
    contractId: string;
    campaignIdentifier: string;
    campaignType: string;
  };

/**
 * - Xinglet: `@xing-com/crate-upsell-checkout-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/checkout/:product/:contractId/:campaignIdentifier/:campaignType`
 */
export const getXingPurchaseCheckoutProductContractIdCampaignIdentifierCampaignTypePath =
  ({
    product,
    contractId,
    campaignIdentifier,
    campaignType,
  }: XingPurchaseCheckoutProductContractIdCampaignIdentifierCampaignTypePathParams): `/purchase/checkout/${string}/${string}/${string}/${string}` =>
    `/purchase/checkout/${encodeURIComponent(product)}/${encodeURIComponent(contractId)}/${encodeURIComponent(campaignIdentifier)}/${encodeURIComponent(campaignType)}`;

export type XingPurchaseCheckoutProductContractIdCampaignIdentifierPathParams =
  {
    product: string;
    contractId: string;
    campaignIdentifier: string;
  };

/**
 * - Xinglet: `@xing-com/crate-upsell-checkout-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/checkout/:product/:contractId/:campaignIdentifier`
 */
export const getXingPurchaseCheckoutProductContractIdCampaignIdentifierPath = ({
  product,
  contractId,
  campaignIdentifier,
}: XingPurchaseCheckoutProductContractIdCampaignIdentifierPathParams): `/purchase/checkout/${string}/${string}/${string}` =>
  `/purchase/checkout/${encodeURIComponent(product)}/${encodeURIComponent(contractId)}/${encodeURIComponent(campaignIdentifier)}`;

export type XingPurchaseCheckoutProductContractIdPathParams = {
  product: string;
  contractId: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-checkout-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/checkout/:product/:contractId`
 */
export const getXingPurchaseCheckoutProductContractIdPath = ({
  product,
  contractId,
}: XingPurchaseCheckoutProductContractIdPathParams): `/purchase/checkout/${string}/${string}` =>
  `/purchase/checkout/${encodeURIComponent(product)}/${encodeURIComponent(contractId)}`;

export type XingPurchaseConfirmationProductPathParams = {
  product: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-confirmation-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/confirmation/:product`
 */
export const getXingPurchaseConfirmationProductPath = ({
  product,
}: XingPurchaseConfirmationProductPathParams): `/purchase/confirmation/${string}` =>
  `/purchase/confirmation/${encodeURIComponent(product)}`;

/**
 * - Xinglet: `@xing-com/crate-upsell-products`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_PURCHASE_PRODUCTS_PATH = '/purchase/products';

export type XingPurchaseProductPathParams = {
  product: string;
};

/**
 * - Xinglet: `@xing-com/crate-upsell-campaign-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/purchase/:product`
 */
export const getXingPurchaseProductPath = ({
  product,
}: XingPurchaseProductPathParams): `/purchase/${string}` =>
  `/purchase/${encodeURIComponent(product)}`;

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-mobile-app-redirect`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_QRCODE_MOBILE_APP_PATH = '/qrcode/mobile-app';

export type XingRecruiterAssistantBriefingDraftBriefingIdPathParams = {
  briefingId: string;
};

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-briefing-form`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 * - Path: `/recruiter-assistant/briefing/draft/:briefingId`
 */
export const getXingRecruiterAssistantBriefingDraftBriefingIdPath = ({
  briefingId,
}: XingRecruiterAssistantBriefingDraftBriefingIdPathParams): `/recruiter-assistant/briefing/draft/${string}` =>
  `/recruiter-assistant/briefing/draft/${encodeURIComponent(briefingId)}`;

export type XingRecruiterAssistantBriefingBriefingIdPathParams = {
  briefingId: string;
};

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-briefing-overview`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 * - Path: `/recruiter-assistant/briefing/:briefingId`
 */
export const getXingRecruiterAssistantBriefingBriefingIdPath = ({
  briefingId,
}: XingRecruiterAssistantBriefingBriefingIdPathParams): `/recruiter-assistant/briefing/${string}` =>
  `/recruiter-assistant/briefing/${encodeURIComponent(briefingId)}`;

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-briefing-form`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 */
export const XING_RECRUITER_ASSISTANT_BRIEFING_PATH =
  '/recruiter-assistant/briefing';

export type XingRecruiterAssistantBriefingsStatusPathParams = {
  status: string;
};

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-main`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 * - Path: `/recruiter-assistant/briefings/:status`
 */
export const getXingRecruiterAssistantBriefingsStatusPath = ({
  status,
}: XingRecruiterAssistantBriefingsStatusPathParams): `/recruiter-assistant/briefings/${string}` =>
  `/recruiter-assistant/briefings/${encodeURIComponent(status)}`;

export type XingRecruiterAssistantEmailReplyResponsePathParams = {
  response: string;
};

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-email-reply`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 * - Path: `/recruiter-assistant/email-reply/:response`
 */
export const getXingRecruiterAssistantEmailReplyResponsePath = ({
  response,
}: XingRecruiterAssistantEmailReplyResponsePathParams): `/recruiter-assistant/email-reply/${string}` =>
  `/recruiter-assistant/email-reply/${encodeURIComponent(response)}`;

/**
 * - Xinglet: `@xing-com/crate-recruiter-assistant-pages-welcome`
 * - Owner: `@xing-com/crate-recruiter-assistant`
 */
export const XING_RECRUITER_ASSISTANT_PATH = '/recruiter-assistant';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_CHECKOUT_PATH =
  '/recruiting/jobs/create/checkout';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_EDITOR_PATH =
  '/recruiting/jobs/create/editor';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_FAILED_PAYMENT_PATH =
  '/recruiting/jobs/create/failed-payment';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_ORDER_CONFIRMATION_PATH =
  '/recruiting/jobs/create/order-confirmation';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_ORDER_SUCCESS_PATH =
  '/recruiting/jobs/create/order-success';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_PREVIEW_PATH =
  '/recruiting/jobs/create/preview';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_PRICING_PATH =
  '/recruiting/jobs/create/pricing';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_PUBLISHED_PATH =
  '/recruiting/jobs/create/published';

/**
 * - Xinglet: `@xing-com/crate-jobs-easy-create-entry`
 * - Owner: `@xing-com/crate-jcom-b2b`
 */
export const XING_RECRUITING_JOBS_CREATE_PATH = '/recruiting/jobs/create';

export type XingRecruitingJobsVouchersMtncVoucherIdPathParams = {
  voucherId: string;
};

/**
 * - Xinglet: `@xing-com/crate-jobs-b2b-mtnc-job-voucher`
 * - Owner: `@xing-com/crate-jcom-b2b`
 * - Path: `/recruiting/jobs/vouchers/mtnc/:voucherId`
 */
export const getXingRecruitingJobsVouchersMtncVoucherIdPath = ({
  voucherId,
}: XingRecruitingJobsVouchersMtncVoucherIdPathParams): `/recruiting/jobs/vouchers/mtnc/${string}` =>
  `/recruiting/jobs/vouchers/mtnc/${encodeURIComponent(voucherId)}`;

/**
 * - Xinglet: `@xing-com/crate-recruiting-settings-pages-job-manager`
 * - Owner: `@xing-com/crate-jobs-b2b`
 */
export const XING_RECRUITING_SETTINGS_JOB_MANAGER_PATH =
  '/recruiting-settings/job-manager';

/**
 * - Xinglet: `@xing-com/crate-recruiting-settings-pages-talent-manager`
 * - Owner: `@xing-com/crate-recruiting-settings`
 */
export const XING_RECRUITING_SETTINGS_TALENT_MANAGER_PATH =
  '/recruiting-settings/talent-manager';

/**
 * - Xinglet: `@xing-com/crate-recruiting-settings-pages-talent-settings`
 * - Owner: `@xing-com/crate-recruiting-settings`
 */
export const XING_RECRUITING_SETTINGS_TALENT_SETTINGS_PATH =
  '/recruiting-settings/talent-settings';

/**
 * - Xinglet: `@xing-com/crate-recruiting-settings-pages-talentpool-manager`
 * - Owner: `@xing-com/crate-recruiting-settings`
 */
export const XING_RECRUITING_SETTINGS_TALENTPOOL_MANAGER_PATH =
  '/recruiting-settings/talentpool-manager';

/**
 * - Xinglet: `@xing-com/crate-recruiting-settings-pages-your-settings`
 * - Owner: `@xing-com/crate-recruiting-settings`
 */
export const XING_RECRUITING_SETTINGS_PATH = '/recruiting-settings';

/**
 * - Xinglet: `@xing-com/crate-ads-reklame`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_REKLAME_IFRAME_PATH = '/reklame/iframe';

/**
 * - Xinglet: `@xing-com/crate-search-companies`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SEARCH_COMPANIES_PATH = '/search/companies';

/**
 * - Xinglet: `@xing-com/crate-search-members`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SEARCH_MEMBERS_PATH = '/search/members';

/**
 * - Xinglet: `@xing-com/crate-seat-manager-assign-licences`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SEAT_MANAGER_SEARCH_PATH = '/seat-manager/search';

/**
 * - Xinglet: `@xing-com/crate-seat-manager-active-licences`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SEAT_MANAGER_PATH = '/seat-manager';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_CREDENTIALS_EMAIL_PATH =
  '/settings/account/credentials/email';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_CREDENTIALS_LOGINS_PATH =
  '/settings/account/credentials/logins';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_CREDENTIALS_PASSWORD_PATH =
  '/settings/account/credentials/password';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_CREDENTIALS_PHONE_PATH =
  '/settings/account/credentials/phone';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_CREDENTIALS_TWOFA_PATH =
  '/settings/account/credentials/twofa';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_DEACTIVATION_PATH =
  '/settings/account/misc/deactivation';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_DELETE_PATH =
  '/settings/account/misc/delete';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_LANGUAGE_PATH =
  '/settings/account/misc/language';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_NAME_PATH =
  '/settings/account/misc/name';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_PREMIUM_SWITCH_PATH =
  '/settings/account/misc/premium-switch';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_THEME_SWITCH_PATH =
  '/settings/account/misc/theme-switch';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_MISC_TIMEZONE_PATH =
  '/settings/account/misc/timezone';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_ACCOUNT_PATH = '/settings/account';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_CREDENTIALS_EMAIL_PATH =
  '/settings/native/account/credentials/email';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_CREDENTIALS_LOGINS_PATH =
  '/settings/native/account/credentials/logins';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_CREDENTIALS_PASSWORD_PATH =
  '/settings/native/account/credentials/password';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_CREDENTIALS_PHONE_PATH =
  '/settings/native/account/credentials/phone';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_CREDENTIALS_TWOFA_PATH =
  '/settings/native/account/credentials/twofa';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_DEACTIVATION_PATH =
  '/settings/native/account/misc/deactivation';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_DELETE_PATH =
  '/settings/native/account/misc/delete';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_LANGUAGE_PATH =
  '/settings/native/account/misc/language';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_NAME_PATH =
  '/settings/native/account/misc/name';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_PREMIUM_SWITCH_PATH =
  '/settings/native/account/misc/premium-switch';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_THEME_SWITCH_PATH =
  '/settings/native/account/misc/theme-switch';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_MISC_TIMEZONE_PATH =
  '/settings/native/account/misc/timezone';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_ACCOUNT_PATH = '/settings/native/account';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_COMMENTS_PATH =
  '/settings/native/notifications/email/network/comments';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_CONTACTS_PATH =
  '/settings/native/notifications/email/network/contacts';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_JOBS_PATH =
  '/settings/native/notifications/email/network/jobs';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_MENTIONS_PATH =
  '/settings/native/notifications/email/network/mentions';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_MESSAGES_PATH =
  '/settings/native/notifications/email/network/messages';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_NETWORK_NEWS_PATH =
  '/settings/native/notifications/email/network/news';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_BASICS_PATH =
  '/settings/native/notifications/email/recommendations/basics';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_JOBS_PATH =
  '/settings/native/notifications/email/recommendations/jobs';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_PREMIUM_PATH =
  '/settings/native/notifications/email/recommendations/premium';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_PRODUCTS_PATH =
  '/settings/native/notifications/email/recommendations/products';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_SPECIALS_PATH =
  '/settings/native/notifications/email/recommendations/specials';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_EMAIL_PATH =
  '/settings/native/notifications/email';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_PUSH_NOTIFICATIONS_PATH =
  '/settings/native/notifications/push-notifications';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_NOTIFICATIONS_PATH =
  '/settings/native/notifications';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_ACTIVITY_FINDABILITY_PATH =
  '/settings/native/privacy/activity/findability';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_ACTIVITY_MESSAGES_PATH =
  '/settings/native/privacy/activity/messages';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_ACTIVITY_STREAMSTORIES_PATH =
  '/settings/native/privacy/activity/streamstories';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_DATA_ADDRESSBOOK_PATH =
  '/settings/native/privacy/data/addressbook';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_DATA_DISCLOSURE_PATH =
  '/settings/native/privacy/data/disclosure';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_DATA_INHERITANCE_PATH =
  '/settings/native/privacy/data/inheritance';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_DATA_TRACKING_PATH =
  '/settings/native/privacy/data/tracking';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_BLOCKED_USERS_PATH =
  '/settings/native/privacy/profile/blocked-users';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_CONTACT_DATA_PATH =
  '/settings/native/privacy/profile/contact-data';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_CONTACTS_PATH =
  '/settings/native/privacy/profile/contacts';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_DATE_OF_BIRTH_PATH =
  '/settings/native/privacy/profile/date-of-birth';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_DISPLAY_PATH =
  '/settings/native/privacy/profile/display';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_FINDABILITY_PATH =
  '/settings/native/privacy/profile/findability';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_MENTIONS_PATH =
  '/settings/native/privacy/profile/mentions';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PROFILE_PORTFOLIO_PATH =
  '/settings/native/privacy/profile/portfolio';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PRIVACY_PATH = '/settings/native/privacy';

export type XingSettingsNativePurchasesBusinessProductsIdBillingAddressPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/business-products/:id/billing-address`
 */
export const getXingSettingsNativePurchasesBusinessProductsIdBillingAddressPath =
  ({
    id,
  }: XingSettingsNativePurchasesBusinessProductsIdBillingAddressPathParams): `/settings/native/purchases/business-products/${string}/billing-address` =>
    `/settings/native/purchases/business-products/${encodeURIComponent(id)}/billing-address`;

export type XingSettingsNativePurchasesBusinessProductsIdInvoicesPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/business-products/:id/invoices`
 */
export const getXingSettingsNativePurchasesBusinessProductsIdInvoicesPath = ({
  id,
}: XingSettingsNativePurchasesBusinessProductsIdInvoicesPathParams): `/settings/native/purchases/business-products/${string}/invoices` =>
  `/settings/native/purchases/business-products/${encodeURIComponent(id)}/invoices`;

export type XingSettingsNativePurchasesBusinessProductsIdPaymentMethodPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/business-products/:id/payment-method`
 */
export const getXingSettingsNativePurchasesBusinessProductsIdPaymentMethodPath =
  ({
    id,
  }: XingSettingsNativePurchasesBusinessProductsIdPaymentMethodPathParams): `/settings/native/purchases/business-products/${string}/payment-method` =>
    `/settings/native/purchases/business-products/${encodeURIComponent(id)}/payment-method`;

export type XingSettingsNativePurchasesBusinessProductsIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/business-products/:id`
 */
export const getXingSettingsNativePurchasesBusinessProductsIdPath = ({
  id,
}: XingSettingsNativePurchasesBusinessProductsIdPathParams): `/settings/native/purchases/business-products/${string}` =>
  `/settings/native/purchases/business-products/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PURCHASES_CONSUMER_PRODUCTS_BILLING_DATA_PATH =
  '/settings/native/purchases/consumer-products/billing-data';

export type XingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdInvoicesPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/consumer-products/subscription-details/:id/invoices`
 */
export const getXingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdInvoicesPath =
  ({
    id,
  }: XingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdInvoicesPathParams): `/settings/native/purchases/consumer-products/subscription-details/${string}/invoices` =>
    `/settings/native/purchases/consumer-products/subscription-details/${encodeURIComponent(id)}/invoices`;

export type XingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/native/purchases/consumer-products/subscription-details/:id`
 */
export const getXingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdPath =
  ({
    id,
  }: XingSettingsNativePurchasesConsumerProductsSubscriptionDetailsIdPathParams): `/settings/native/purchases/consumer-products/subscription-details/${string}` =>
    `/settings/native/purchases/consumer-products/subscription-details/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PURCHASES_PATH = '/settings/native/purchases';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NATIVE_PATH = '/settings/native';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_COMMENTS_PATH =
  '/settings/notifications/email/network/comments';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_CONTACTS_PATH =
  '/settings/notifications/email/network/contacts';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_JOBS_PATH =
  '/settings/notifications/email/network/jobs';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_MENTIONS_PATH =
  '/settings/notifications/email/network/mentions';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_MESSAGES_PATH =
  '/settings/notifications/email/network/messages';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_NETWORK_NEWS_PATH =
  '/settings/notifications/email/network/news';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_BASICS_PATH =
  '/settings/notifications/email/recommendations/basics';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_JOBS_PATH =
  '/settings/notifications/email/recommendations/jobs';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_PREMIUM_PATH =
  '/settings/notifications/email/recommendations/premium';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_PRODUCTS_PATH =
  '/settings/notifications/email/recommendations/products';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_RECOMMENDATIONS_SPECIALS_PATH =
  '/settings/notifications/email/recommendations/specials';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_EMAIL_PATH =
  '/settings/notifications/email';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_PUSH_NOTIFICATIONS_PATH =
  '/settings/notifications/push-notifications';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_NOTIFICATIONS_PATH = '/settings/notifications';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_ACTIVITY_FINDABILITY_PATH =
  '/settings/privacy/activity/findability';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_ACTIVITY_MESSAGES_PATH =
  '/settings/privacy/activity/messages';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_ACTIVITY_STREAMSTORIES_PATH =
  '/settings/privacy/activity/streamstories';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_DATA_ADDRESSBOOK_PATH =
  '/settings/privacy/data/addressbook';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_DATA_DISCLOSURE_PATH =
  '/settings/privacy/data/disclosure';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_DATA_INHERITANCE_PATH =
  '/settings/privacy/data/inheritance';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_DATA_TRACKING_PATH =
  '/settings/privacy/data/tracking';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_BLOCKED_USERS_PATH =
  '/settings/privacy/profile/blocked-users';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_CONTACT_DATA_PATH =
  '/settings/privacy/profile/contact-data';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_CONTACTS_PATH =
  '/settings/privacy/profile/contacts';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_DATE_OF_BIRTH_PATH =
  '/settings/privacy/profile/date-of-birth';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_DISPLAY_PATH =
  '/settings/privacy/profile/display';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_FINDABILITY_PATH =
  '/settings/privacy/profile/findability';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_MENTIONS_PATH =
  '/settings/privacy/profile/mentions';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PROFILE_PORTFOLIO_PATH =
  '/settings/privacy/profile/portfolio';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PRIVACY_PATH = '/settings/privacy';

export type XingSettingsPurchasesBusinessProductsIdBillingAddressPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/business-products/:id/billing-address`
 */
export const getXingSettingsPurchasesBusinessProductsIdBillingAddressPath = ({
  id,
}: XingSettingsPurchasesBusinessProductsIdBillingAddressPathParams): `/settings/purchases/business-products/${string}/billing-address` =>
  `/settings/purchases/business-products/${encodeURIComponent(id)}/billing-address`;

export type XingSettingsPurchasesBusinessProductsIdInvoicesPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/business-products/:id/invoices`
 */
export const getXingSettingsPurchasesBusinessProductsIdInvoicesPath = ({
  id,
}: XingSettingsPurchasesBusinessProductsIdInvoicesPathParams): `/settings/purchases/business-products/${string}/invoices` =>
  `/settings/purchases/business-products/${encodeURIComponent(id)}/invoices`;

export type XingSettingsPurchasesBusinessProductsIdPaymentMethodPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/business-products/:id/payment-method`
 */
export const getXingSettingsPurchasesBusinessProductsIdPaymentMethodPath = ({
  id,
}: XingSettingsPurchasesBusinessProductsIdPaymentMethodPathParams): `/settings/purchases/business-products/${string}/payment-method` =>
  `/settings/purchases/business-products/${encodeURIComponent(id)}/payment-method`;

export type XingSettingsPurchasesBusinessProductsIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/business-products/:id`
 */
export const getXingSettingsPurchasesBusinessProductsIdPath = ({
  id,
}: XingSettingsPurchasesBusinessProductsIdPathParams): `/settings/purchases/business-products/${string}` =>
  `/settings/purchases/business-products/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PURCHASES_CONSUMER_PRODUCTS_BILLING_DATA_PATH =
  '/settings/purchases/consumer-products/billing-data';

export type XingSettingsPurchasesConsumerProductsSubscriptionDetailsIdInvoicesPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/consumer-products/subscription-details/:id/invoices`
 */
export const getXingSettingsPurchasesConsumerProductsSubscriptionDetailsIdInvoicesPath =
  ({
    id,
  }: XingSettingsPurchasesConsumerProductsSubscriptionDetailsIdInvoicesPathParams): `/settings/purchases/consumer-products/subscription-details/${string}/invoices` =>
    `/settings/purchases/consumer-products/subscription-details/${encodeURIComponent(id)}/invoices`;

export type XingSettingsPurchasesConsumerProductsSubscriptionDetailsIdPathParams =
  {
    id: string;
  };

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/settings/purchases/consumer-products/subscription-details/:id`
 */
export const getXingSettingsPurchasesConsumerProductsSubscriptionDetailsIdPath =
  ({
    id,
  }: XingSettingsPurchasesConsumerProductsSubscriptionDetailsIdPathParams): `/settings/purchases/consumer-products/subscription-details/${string}` =>
    `/settings/purchases/consumer-products/subscription-details/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PURCHASES_PATH = '/settings/purchases';

/**
 * - Xinglet: `@xing-com/crate-settings-settings`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SETTINGS_PATH = '/settings';

/**
 * - Xinglet: `@xing-com/crate-social-share-xinglet`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SOCIAL_SHARE_SPI_PATH = '/social/share/spi';

/**
 * - Xinglet: `@xing-com/crate-social-share-xinglet`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SOCIAL_SHARE_PATH = '/social/share';

/**
 * - Xinglet: `@xing-com/crate-login-completion`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_START_COMPLETION_PATH = '/start/completion';

/**
 * - Xinglet: `@xing-com/crate-login-confirmation`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_START_CONFIRMATION_PATH = '/start/confirmation';

/**
 * - Xinglet: `@xing-com/crate-login-first-login`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_START_FIRST_LOGIN_PATH = '/start/first_login';

/**
 * - Xinglet: `@xing-com/crate-login-registration`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_START_SIGNUP_PATH = '/start/signup';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_START_PATH = '/start';

/**
 * - Xinglet: `@xing-com/crate-support-contact-success`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SUPPORT_CONTACT_SUCCESS_PATH = '/support/contact/success';

export type XingSupportContactTopicSubjectPathParams = {
  topic: string;
  subject: string;
};

/**
 * - Xinglet: `@xing-com/crate-support-contact-main`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/support/contact/:topic/:subject`
 */
export const getXingSupportContactTopicSubjectPath = ({
  topic,
  subject,
}: XingSupportContactTopicSubjectPathParams): `/support/contact/${string}/${string}` =>
  `/support/contact/${encodeURIComponent(topic)}/${encodeURIComponent(subject)}`;

export type XingSupportContactTopicPathParams = {
  topic: string;
};

/**
 * - Xinglet: `@xing-com/crate-support-contact-main`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/support/contact/:topic`
 */
export const getXingSupportContactTopicPath = ({
  topic,
}: XingSupportContactTopicPathParams): `/support/contact/${string}` =>
  `/support/contact/${encodeURIComponent(topic)}`;

/**
 * - Xinglet: `@xing-com/crate-support-contact-main`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_SUPPORT_CONTACT_PATH = '/support/contact';

export type XingTeampermissionsCompanyCompanyIdPathParams = {
  companyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-companies-teampermissions`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/teampermissions/company/:companyId`
 */
export const getXingTeampermissionsCompanyCompanyIdPath = ({
  companyId,
}: XingTeampermissionsCompanyCompanyIdPathParams): `/teampermissions/company/${string}` =>
  `/teampermissions/company/${encodeURIComponent(companyId)}`;

/**
 * - Xinglet: `@xing-com/crate-companies-teampermissions`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_TEAMPERMISSIONS_PATH = '/teampermissions';

export type XingTermsSlugPathParams = {
  slug: string;
};

/**
 * - Xinglet: `@xing-com/crate-legal-pages-term-content`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/terms/:slug`
 */
export const getXingTermsSlugPath = ({
  slug,
}: XingTermsSlugPathParams): `/terms/${string}` =>
  `/terms/${encodeURIComponent(slug)}`;

/**
 * - Xinglet: `@xing-com/crate-legal-pages-terms`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_TERMS_PATH = '/terms';

/**
 * - Xinglet: `@xing-com/crate-video-video-iframe`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_VIDEO_IFRAME_PATH = '/video-iframe';

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_AAC_ERROR_NO_ACCOUNT_PATH = '/xam/aac/error-no-account';

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_AAC_ERROR_UNAUTHORIZED_PATH =
  '/xam/aac/error-unauthorized';

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_AAC_PATH = '/xam/aac';

export type XingXamAgenciesAgencyIdAdministrationCrmPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/crm`
 */
export const getXingXamAgenciesAgencyIdAdministrationCrmPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdAdministrationCrmPathParams): `/xam/agencies/${string}/administration/crm` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/administration/crm`;

export type XingXamAgenciesAgencyIdAdministrationCustomersNewPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/customers/new`
 */
export const getXingXamAgenciesAgencyIdAdministrationCustomersNewPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdAdministrationCustomersNewPathParams): `/xam/agencies/${string}/administration/customers/new` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/administration/customers/new`;

export type XingXamAgenciesAgencyIdAdministrationCustomersCustomerIdEditClientIdPathParams =
  {
    agencyId: string;
    customerId: string;
    clientId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/customers/:customerId/edit/:clientId`
 */
export const getXingXamAgenciesAgencyIdAdministrationCustomersCustomerIdEditClientIdPath =
  ({
    agencyId,
    customerId,
    clientId,
  }: XingXamAgenciesAgencyIdAdministrationCustomersCustomerIdEditClientIdPathParams): `/xam/agencies/${string}/administration/customers/${string}/edit/${string}` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/administration/customers/${encodeURIComponent(customerId)}/edit/${encodeURIComponent(clientId)}`;

export type XingXamAgenciesAgencyIdAdministrationCustomersCustomerIdPathParams =
  {
    agencyId: string;
    customerId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/customers/:customerId`
 */
export const getXingXamAgenciesAgencyIdAdministrationCustomersCustomerIdPath =
  ({
    agencyId,
    customerId,
  }: XingXamAgenciesAgencyIdAdministrationCustomersCustomerIdPathParams): `/xam/agencies/${string}/administration/customers/${string}` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/administration/customers/${encodeURIComponent(customerId)}`;

export type XingXamAgenciesAgencyIdAdministrationCustomersPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/customers`
 */
export const getXingXamAgenciesAgencyIdAdministrationCustomersPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdAdministrationCustomersPathParams): `/xam/agencies/${string}/administration/customers` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/administration/customers`;

export type XingXamAgenciesAgencyIdAdministrationUsersPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration/users`
 */
export const getXingXamAgenciesAgencyIdAdministrationUsersPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdAdministrationUsersPathParams): `/xam/agencies/${string}/administration/users` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/administration/users`;

export type XingXamAgenciesAgencyIdAdministrationPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/administration`
 */
export const getXingXamAgenciesAgencyIdAdministrationPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdAdministrationPathParams): `/xam/agencies/${string}/administration` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/administration`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesNewPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/audiences/new`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdAudiencesNewPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesNewPathParams): `/xam/agencies/${string}/customers/${string}/audiences/new` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/audiences/new`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesRetargetingNewPathParams =
  {
    agencyId: string;
    customerId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/audiences/retargeting/new`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdAudiencesRetargetingNewPath =
  ({
    agencyId,
    customerId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesRetargetingNewPathParams): `/xam/agencies/${string}/customers/${string}/audiences/retargeting/new` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/audiences/retargeting/new`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdClonePathParams =
  {
    agencyId: string;
    customerId: string;
    audienceId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/audiences/:audienceId/clone`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdClonePath =
  ({
    agencyId,
    customerId,
    audienceId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdClonePathParams): `/xam/agencies/${string}/customers/${string}/audiences/${string}/clone` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/audiences/${encodeURIComponent(audienceId)}/clone`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdEditPathParams =
  {
    agencyId: string;
    customerId: string;
    audienceId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/audiences/:audienceId/edit`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdEditPath =
  ({
    agencyId,
    customerId,
    audienceId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesAudienceIdEditPathParams): `/xam/agencies/${string}/customers/${string}/audiences/${string}/edit` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/audiences/${encodeURIComponent(audienceId)}/edit`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/audiences`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdAudiencesPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdAudiencesPathParams): `/xam/agencies/${string}/customers/${string}/audiences` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/audiences`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsChooseGoalPathParams =
  {
    agencyId: string;
    customerId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/choose-goal`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsChooseGoalPath =
  ({
    agencyId,
    customerId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsChooseGoalPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/choose-goal` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/choose-goal`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsNewPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/new`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsNewPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsNewPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/new` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/new`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewAdTypePathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adType: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/new/:adType`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewAdTypePath =
  ({
    agencyId,
    customerId,
    campaignId,
    adType,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewAdTypePathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/new/${string}` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/new/${encodeURIComponent(adType)}`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/new`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewPath =
  ({
    agencyId,
    customerId,
    campaignId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsNewPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/new` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/new`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdDuplicatePathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/:adId/duplicate`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdDuplicatePath =
  ({
    agencyId,
    customerId,
    campaignId,
    adId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdDuplicatePathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/${string}/duplicate` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/${encodeURIComponent(adId)}/duplicate`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdEditPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/:adId/edit`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdEditPath =
  ({
    agencyId,
    customerId,
    campaignId,
    adId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdEditPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/${string}/edit` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/${encodeURIComponent(adId)}/edit`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormEditPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/:adId/form/edit`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormEditPath =
  ({
    agencyId,
    customerId,
    campaignId,
    adId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormEditPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/${string}/form/edit` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/${encodeURIComponent(adId)}/form/edit`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormNewPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/:adId/form/new`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormNewPath =
  ({
    agencyId,
    customerId,
    campaignId,
    adId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdFormNewPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/${string}/form/new` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/${encodeURIComponent(adId)}/form/new`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
    adId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads/:adId`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdPath =
  ({
    agencyId,
    customerId,
    campaignId,
    adId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsAdIdPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads/${string}` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads/${encodeURIComponent(adId)}`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/ads`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsPath =
  ({
    agencyId,
    customerId,
    campaignId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdAdsPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/ads` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/ads`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdEditPathParams =
  {
    agencyId: string;
    customerId: string;
    campaignId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns/:campaignId/edit`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdEditPath =
  ({
    agencyId,
    customerId,
    campaignId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsCampaignIdEditPathParams): `/xam/agencies/${string}/customers/${string}/campaigns/${string}/edit` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns/${encodeURIComponent(campaignId)}/edit`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/campaigns`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdCampaignsPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdCampaignsPathParams): `/xam/agencies/${string}/customers/${string}/campaigns` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/campaigns`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdFileManagerPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/file-manager`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdFileManagerPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdFileManagerPathParams): `/xam/agencies/${string}/customers/${string}/file-manager` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/file-manager`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdInvoicesPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/invoices`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdInvoicesPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdInvoicesPathParams): `/xam/agencies/${string}/customers/${string}/invoices` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/invoices`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelPathParams =
  {
    agencyId: string;
    customerId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/tracking-pixel`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelPathParams): `/xam/agencies/${string}/customers/${string}/tracking-pixel` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/tracking-pixel`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelInstallPathParams =
  {
    agencyId: string;
    customerId: string;
  };

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/tracking-pixel-install`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelInstallPath =
  ({
    agencyId,
    customerId,
  }: XingXamAgenciesAgencyIdCustomersCustomerIdTrackingPixelInstallPathParams): `/xam/agencies/${string}/customers/${string}/tracking-pixel-install` =>
    `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/tracking-pixel-install`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdVouchersPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId/vouchers`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdVouchersPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdVouchersPathParams): `/xam/agencies/${string}/customers/${string}/vouchers` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}/vouchers`;

export type XingXamAgenciesAgencyIdCustomersCustomerIdPathParams = {
  agencyId: string;
  customerId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers/:customerId`
 */
export const getXingXamAgenciesAgencyIdCustomersCustomerIdPath = ({
  agencyId,
  customerId,
}: XingXamAgenciesAgencyIdCustomersCustomerIdPathParams): `/xam/agencies/${string}/customers/${string}` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers/${encodeURIComponent(customerId)}`;

export type XingXamAgenciesAgencyIdCustomersPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId/customers`
 */
export const getXingXamAgenciesAgencyIdCustomersPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdCustomersPathParams): `/xam/agencies/${string}/customers` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}/customers`;

export type XingXamAgenciesAgencyIdPathParams = {
  agencyId: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/agencies/:agencyId`
 */
export const getXingXamAgenciesAgencyIdPath = ({
  agencyId,
}: XingXamAgenciesAgencyIdPathParams): `/xam/agencies/${string}` =>
  `/xam/agencies/${encodeURIComponent(agencyId)}`;

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_AGENCIES_PATH = '/xam/agencies';

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_HUBSPOT_PATH = '/xam/hubspot';

export type XingXamManagementRequestsIdPathParams = {
  id: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/management_requests/:id`
 */
export const getXingXamManagementRequestsIdPath = ({
  id,
}: XingXamManagementRequestsIdPathParams): `/xam/management_requests/${string}` =>
  `/xam/management_requests/${encodeURIComponent(id)}`;

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_MISSING_AGENCY_ERROR_PATH = '/xam/missing-agency-error';

export type XingXamPreviewsShareUuidPathParams = {
  share_uuid: string;
};

/**
 * - Xinglet: `@xing-com/crate-xam-previews`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xam/previews/:share_uuid`
 */
export const getXingXamPreviewsShareUuidPath = ({
  share_uuid,
}: XingXamPreviewsShareUuidPathParams): `/xam/previews/${string}` =>
  `/xam/previews/${encodeURIComponent(share_uuid)}`;

/**
 * - Xinglet: `@xing-com/crate-xam-previews`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_PREVIEWS_PATH = '/xam/previews';

/**
 * - Xinglet: `@xing-com/crate-xam-manager`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XAM_PATH = '/xam';

/**
 * - Xinglet: `@xing-com/crate-activity-center-test-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_QA_ACTIVITY_CENTER_PATH =
  '/xingternal/_qa/activity-center';

export type XingXingternalAdsDetailViewAdIdPathParams = {
  adId: string;
};

/**
 * - Xinglet: `@xing-com/crate-ads-detail-view`
 * - Owner: `@xing-com/crate-marketing-solutions`
 * - Path: `/xingternal/ads/detail-view/:adId`
 */
export const getXingXingternalAdsDetailViewAdIdPath = ({
  adId,
}: XingXingternalAdsDetailViewAdIdPathParams): `/xingternal/ads/detail-view/${string}` =>
  `/xingternal/ads/detail-view/${encodeURIComponent(adId)}`;

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_BIRTHDAYS_PATH =
  '/xingternal/ads/showcase/birthdays';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_DISCOUPDATES_PATH =
  '/xingternal/ads/showcase/discoupdates';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSDETAILS_PATH =
  '/xingternal/ads/showcase/jobsdetails';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSDREAMMACHINE_PATH =
  '/xingternal/ads/showcase/jobsdreammachine';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSINLINE_PATH =
  '/xingternal/ads/showcase/jobsinline';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSJOBLIST_PATH =
  '/xingternal/ads/showcase/jobsjoblist';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSRECOMMENDATION_PATH =
  '/xingternal/ads/showcase/jobsrecommendation';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSRECOMMENDATIONMYJOBS_PATH =
  '/xingternal/ads/showcase/jobsrecommendationmyjobs';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_JOBSSEARCH_PATH =
  '/xingternal/ads/showcase/jobssearch';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_LOGOUT_PATH =
  '/xingternal/ads/showcase/logout';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_MESSENGER_PATH =
  '/xingternal/ads/showcase/messenger';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_NETWORK_PATH =
  '/xingternal/ads/showcase/network';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_NOTIFICATIONCENTER_PATH =
  '/xingternal/ads/showcase/notificationcenter';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_PROFILE_PATH =
  '/xingternal/ads/showcase/profile';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_SEARCH_PATH =
  '/xingternal/ads/showcase/search';

/**
 * - Xinglet: `@xing-com/crate-ads-showcase`
 * - Owner: `@xing-com/crate-marketing-solutions`
 */
export const XING_XINGTERNAL_ADS_SHOWCASE_PATH = '/xingternal/ads/showcase';

/**
 * - Xinglet: `@xing-com/crate-login-blacklisted`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_DEACTIVATED_PATH = '/xingternal/deactivated';

/**
 * - Xinglet: `@xing-com/crate-layout-b2b`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_LAYOUT_B2B_PATH = '/xingternal/layout/b2b';

export type XingXingternalLocalhostProfileVersionEmbeddedPageNameTabPathParams =
  {
    pageName: string;
    tab: string;
  };

/**
 * - Xinglet: `@xing-com/crate-profile-modules-other-web-profiles-portfolio-iframe-tabs-mock-pages`
 * - Owner: `@xing-com/crate-profile`
 * - Path: `/xingternal/localhost-profile/version/embedded/:pageName/:tab`
 */
export const getXingXingternalLocalhostProfileVersionEmbeddedPageNameTabPath =
  ({
    pageName,
    tab,
  }: XingXingternalLocalhostProfileVersionEmbeddedPageNameTabPathParams): `/xingternal/localhost-profile/version/embedded/${string}/${string}` =>
    `/xingternal/localhost-profile/version/embedded/${encodeURIComponent(pageName)}/${encodeURIComponent(tab)}`;

/**
 * - Xinglet: `@xing-com/crate-login-login-with-onlyfy`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_LOGIN_ONLYFY_CONNECT_PATH =
  '/xingternal/login/onlyfy/connect';

/**
 * - Xinglet: `@xing-com/crate-login-login`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_LOGIN_PATH = '/xingternal/login';

/**
 * - Xinglet: `@xing-com/crate-login-logout`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_LOGOUT_PATH = '/xingternal/logout';

/**
 * - Xinglet: `@xing-com/crate-settings-mock-credit-card-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_MOCK_CREDIT_CARD_PAGE_PATH =
  '/xingternal/mock-credit-card-page';

/**
 * - Xinglet: `@xing-com/crate-settings-mock-paypal-page`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_MOCK_PAYPAL_PAGE_PATH =
  '/xingternal/mock-paypal-page';

/**
 * - Xinglet: `@xing-com/crate-payments-internal-test-pages`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PAYMENTS_B2C_EMBEDDABLE_TESTS_PATH =
  '/xingternal/payments/b2c-embeddable-tests';

/**
 * - Xinglet: `@xing-com/crate-payments-internal-test-pages`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PAYMENTS_CLIENT_BILLING_ADDRESS_PATH =
  '/xingternal/payments/client-billing-address';

/**
 * - Xinglet: `@xing-com/crate-payments-internal-test-pages`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PAYMENTS_CLIENT_PAYMENT_DATA_PATH =
  '/xingternal/payments/client-payment-data';

export type XingXingternalPlatformErrorPagesCodePathParams = {
  code: string;
};

/**
 * - Xinglet: `@xing-com/crate-communication-error-pages-for-export`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/xingternal/platform/error-pages/:code`
 */
export const getXingXingternalPlatformErrorPagesCodePath = ({
  code,
}: XingXingternalPlatformErrorPagesCodePathParams): `/xingternal/platform/error-pages/${string}` =>
  `/xingternal/platform/error-pages/${encodeURIComponent(code)}`;

/**
 * - Xinglet: `@xing-com/crate-communication-error-pages-for-export`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_ERROR_PAGES_PATH =
  '/xingternal/platform/error-pages';

/**
 * - Xinglet: `@xing-com/crate-layout-example`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_EXAMPLES_PATH =
  '/xingternal/platform/examples';

/**
 * - Xinglet: `@xing-com/crate-layout-grid-demo-stickyness`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_GRID_DEMO_STICKYNESS_PATH =
  '/xingternal/platform/grid/demo-stickyness';

export type XingXingternalPlatformGridDemoVariantsVariantPathParams = {
  variant: string;
};

/**
 * - Xinglet: `@xing-com/crate-layout-grid-demo-variants`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 * - Path: `/xingternal/platform/grid/demo-variants/:variant`
 */
export const getXingXingternalPlatformGridDemoVariantsVariantPath = ({
  variant,
}: XingXingternalPlatformGridDemoVariantsVariantPathParams): `/xingternal/platform/grid/demo-variants/${string}` =>
  `/xingternal/platform/grid/demo-variants/${encodeURIComponent(variant)}`;

/**
 * - Xinglet: `@xing-com/crate-communication-demo-hub`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_HUB_PATH = '/xingternal/platform/hub';

/**
 * - Xinglet: `@xing-com/crate-communication-demo-polyfills`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_POLYFILLS_PATH =
  '/xingternal/platform/polyfills';

/**
 * - Xinglet: `@xing-com/crate-communication-demo-routes`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_ROUTES_PATH =
  '/xingternal/platform/routes';

/**
 * - Xinglet: `@xing-com/crate-layout-scroll-manager-example-1`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_SCROLL_MANAGER_PATH =
  '/xingternal/platform/scroll-manager';

/**
 * - Xinglet: `@xing-com/crate-layout-scroll-manager-example-2`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_SCROLL_MANAGER_2_PATH =
  '/xingternal/platform/scroll-manager-2';

/**
 * - Xinglet: `@xing-com/crate-communication-demo-xinglet-loading`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_PLATFORM_XINGLET_LOADING_PATH =
  '/xingternal/platform/xinglet-loading';

/**
 * - Xinglet: `@xing-com/crate-login-reactivation`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_REACTIVATION_PATH = '/xingternal/reactivation';

/**
 * - Xinglet: `@xing-com/crate-login-no-access-account-recovery`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_RECOVERY_ACCOUNT_FORGOT_CREDENTIALS_PATH =
  '/xingternal/recovery/account/forgot-credentials';

/**
 * - Xinglet: `@xing-com/crate-login-no-access-account-recovery`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_RECOVERY_ACCOUNT_NO_ACCESS_PATH =
  '/xingternal/recovery/account/no-access';

/**
 * - Xinglet: `@xing-com/crate-login-no-access-success-page`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_RECOVERY_ACCOUNT_SUCCESS_PATH =
  '/xingternal/recovery/account/success';

/**
 * - Xinglet: `@xing-com/crate-login-password-reset`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_RECOVERY_PASSWORD_NEW_PATH =
  '/xingternal/recovery/password/new';

/**
 * - Xinglet: `@xing-com/crate-login-password-reset`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_RECOVERY_PATH = '/xingternal/recovery';

/**
 * - Xinglet: `@xing-com/crate-login-post-login`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_SECURITY_CHECK_PATH = '/xingternal/security-check';

/**
 * - Xinglet: `@xing-com/crate-login-two-factor-auth-backup`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_TFA_BACKUP_PATH = '/xingternal/tfa/backup';

/**
 * - Xinglet: `@xing-com/crate-login-two-factor-auth-sms`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_TFA_SMS_PATH = '/xingternal/tfa/sms';

/**
 * - Xinglet: `@xing-com/crate-login-two-factor-auth-app`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_TFA_APP_PATH = '/xingternal/tfa-app';

/**
 * - Xinglet: `@xing-com/crate-login-job-coach-prototype`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_XINGTERNAL_WEEKLY_CHECK_IN_PATH =
  '/xingternal/weekly-check-in';

/**
 * - Xinglet: `@xing-com/crate-winery-demo`
 * - Owner: `@xing-com/crate-foundations-and-sustainability`
 */
export const XING_XINGTERNAL_WINERY_UI_PATH = '/xingternal/winery-ui';

/**
 * - Xinglet: `@xing-com/crate-startpage-logged-out-entry`
 * - Owner: `@xing-com/crate-seo-and-logged-out`
 */
export const XING_PATH = '/';
